"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8533],{

/***/ 63802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ wlDatas; }
/* harmony export */ });
var wlDatas = {
    attributes: {
        campanha_default: "VolttaWebApp",
        empresa: "Voltta",
        bg_color: null,
        cor_hover_botao_icon: "#99E8B4",
        usar_configuracao_padrao: false,
        steps_contratacao_pf: [
            {
                name: "Dados Pessoais",
                index: "1"
            },
            {
                name: "Endere\xe7o",
                index: "2"
            },
            {
                name: "Identifica\xe7\xe3o",
                index: "3"
            },
            {
                name: "Conta de luz",
                index: "4"
            },
            {
                name: "Confirma\xe7\xe3o",
                index: "5"
            },
            {
                name: "Assinatura de Contrato",
                index: "6"
            }, 
        ],
        steps_contratacao_pj: [
            {
                name: "Dados da empresa",
                index: "1"
            },
            {
                name: "Identifica\xe7\xe3o",
                index: "2"
            },
            {
                name: "Conta de luz",
                index: "3"
            },
            {
                name: "Confirma\xe7\xe3o",
                index: "4"
            },
            {
                name: "Assinatura de Contrato",
                index: "5"
            }, 
        ],
        steps_contratacao_ml: [
            {
                name: "Dados da empresa",
                index: "1"
            },
            {
                name: "Identifica\xe7\xe3o",
                index: "2"
            },
            {
                name: "Assinatura de contrato",
                index: "3"
            }, 
        ],
        steps_dashboard_pf: [
            {
                name: "Usina selecionada",
                index: "1"
            },
            {
                name: "Contrato submetido para an\xe1lise",
                index: "2"
            },
            {
                name: "Contrato assinado com a usina",
                index: "3"
            },
            {
                name: "Seu desconto chegou!",
                index: "4"
            }, 
        ],
        steps_dashboard_pj: [
            {
                name: "Usina selecionada",
                index: "1"
            },
            {
                name: "Contrato submetido para an\xe1lise",
                index: "2"
            },
            {
                name: "Contrato assinado com a usina",
                index: "3"
            },
            {
                name: "Seu desconto chegou!",
                index: "4"
            }, 
        ],
        steps_dashboard_ml: [
            {
                name: "Contato comercial",
                index: "1"
            },
            {
                name: "Sele\xe7\xe3o de comercializadora ",
                index: "2"
            },
            {
                name: "Envio de documentos e assinatura de contrato",
                index: "3"
            },
            {
                name: "Assinatura de contrato com a comercializadora",
                index: "4"
            },
            {
                name: "Desconto ativo",
                index: "5"
            }, 
        ],
        config_campos_pipefy_data: {
            nome: "nome",
            sobrenome: "sobrenome",
            email: "email",
            celular: "n_mero_de_telefone",
            municipio: "cidade",
            estado: "estado",
            estado_combo: "estados_combobox",
            tipo_conta: "para_sua_casa_ou_para_seu_neg_cio_2",
            valor_medio_mensal_da_conta: "valor_m_dio_mensal_na_conta_de_luz",
            representante: "campanha",
            assessor: "acessores",
            clique_ver_ofertas_disponiveis: "clique_cta_ver_ofertas_dispon_veis",
            economia_estimada: "economia_estimada",
            concessionaria_pipe: "concessionaria",
            usina_ofertada_pipe: "geradora_escolhida",
            clique_cta_usina_listing_pipe: "geradora_listing",
            clique_cta1_card_usina_pipe: "clicou_cta_1_geradora",
            clique_cta2_card_usina_pipe: "clicou_cta_2_geradora",
            disponibilidade_atendimento: "disponibilidade_atendimento",
            nome_concessionaria: "concessionaria_new",
            nome_usina_ofertada: "lista_1",
            nome_concessionaria_txt: "concessionaria_txt_1",
            nome_usina_ofertada_txt: "geradora_txt_1",
            clique_cta_usina_listing_nome: "geradora_listing_new",
            clique_cta1_card_usina_listing_nome: "clique_cta1_card_geradora_new",
            clique_cta2_card_usina_listing_nome: "copy_of_clique_cta1_card_geradora_new",
            clique_cta_solicitar_ml: "fale_com_nosso_time",
            mercado_livre: "cliente_mercado_livre",
            nome_contrato: "nome_contrato",
            cnpj: "cnpj",
            cpf: "cpf",
            cep: "cep",
            endereco_rua: "rua",
            complemento: "complemento",
            numero: "n_mero",
            completou_fluxo: "completou_o_fluxo",
            engajamento_com_proposta_de_valor: "engajamento_com_proposta_de_valor",
            logou_na_plataforma: "clicou_cta_entrar",
            clique_cta_continuar1_ml: "clicou_cta_1_de_ml_continuar",
            clique_cta_continuar2_ml: "clicou_cta_2_de_ml_continuar",
            conta_de_luz_enviada: "conta_de_luz_enviada",
            codigo_validado: "c_digo_validado",
            confirmacao_dados: "confirma_o_de_dados",
            origem_api: "origem_api"
        },
        config_campos_pipefy_step: {},
        config_campos_sharpspring: {
            cep: "cep_632722cc60e5b",
            cpf: "cpf_63272c763e68f",
            kwh: "kwh_636463b37e3e5",
            city: "city",
            cnpj: "cnpj_638f40958ef62",
            nome_contrato: "nome_do_contratante_637672c65a776",
            email: "emailAddress",
            state: "state",
            title: "title",
            active: "active",
            estado: "estado_br_63272aa7507fd",
            numero: "n__mero_636af156a0648",
            status: "status",
            street: "street",
            celular: "phoneNumber",
            country: "country",
            ownerID: "ownerID",
            persona: "persona",
            website: "website",
            zipcode: "zipcode",
            industry: "industry",
            pessoa_f: "pessoa_f__sica_632721dc6a4e4",
            accountID: "accountID",
            faxNumber: "faxNumber",
            firstName: "firstName",
            isContact: "isContact",
            leadScore: "leadScore",
            municipio: "munic__pio_632723186b971",
            campaignID: "campaignID",
            isCustomer: "isCustomer",
            leadStatus: "leadStatus",
            pessoa_jur: "pessoa_jur__dica__632722135ac4d",
            trackingID: "trackingID",
            companyName: "companyName",
            complemento: "complemento_636af299c28af",
            description: "description",
            isQualified: "isQualified",
            emailAddress: "emailAddress",
            endereco_rua: "endere__o_rua_632722fb24df9",
            lista_espera: "est___na_lista_de_espera__636c140ab9171",
            mercado_livre: "mercado_livre_6480debf37b28",
            concessionaria: "concession__ria_63272b2dc7930",
            isUnsubscribed: "isUnsubscribed",
            url_identidade: "documento_de_identidade__produto__64ca9e60f263c",
            usina_ofertada: "usina_ofertada_63272c5479152",
            completou_fluxo: "contrato_assinado__63272dd25a120",
            consumo_de_pico: "consumo_de_pico_63272b55ee53c",
            createTimestamp: "createTimestamp",
            periodo_de_pico: "per__odo_de_pico_633c271c6bc78",
            tipo_de_moradia: "tipo_de_moradia_633c27bce07ab",
            updateTimestamp: "updateTimestamp",
            url_conta_de_luz: "conta_de_luz__produto__64ca9e74bc7df",
            economia_estimada: "economia_estimada_63272b7386d0b",
            leadScoreWeighted: "leadScoreWeighted",
            mobilePhoneNumber: "mobilePhoneNumber",
            logou_na_plataforma: "clique_ver_ofertas_dispon__veis_647739e4342ab ",
            municipio_uf_espera: "munic__pio_uf_em_espera_636c14369ad87",
            onboarding_1_submit: "input_id",
            onboarding_2_submit: "input_id",
            onboarding_3_submit: "input_id",
            onboarding_4_submit: "input_id",
            onboarding_5_submit: "input_id",
            onboarding_6_submit: "input_id",
            unidade_consumidora: "unidade_consumidora_63647219059c7",
            url_contrato_social: "contrato_social__produto__64ca9e86a95c0",
            conta_de_luz_enviada: "conta_de_luz_enviada__63272d2beab87",
            ml_contrato_assinado: "ml_contrato_assinado_649322802595c",
            phoneNumberExtension: "phoneNumberExtension",
            clique_cta1_card_usina: "clique_cta_usina_listing__1__6477b9422e135",
            clique_cta2_card_usina: "clique_cta_usina_listing__1___1__6477b94bb741b",
            clique_cta_solicitar_ml: "clique_cta_solicitar_ml_6491fd92a31de",
            clique_cta_continuar1_ml: "clique_cta_continuar1_ml_6491fddf70b46",
            clique_cta_continuar2_ml: "clique_cta_continuar2_ml_6491fdff2563f",
            clique_cta_usina_listing: "cta_usina_listing_jacarepagua_64773c4d987ee",
            quantos_residentes_na_casa: "quantos_residentes_na_casa__633c28b16396e",
            clique_cta_ver_propostas_ml: "p__s_login_clique_cta_ver_propostas_64931ee291e99",
            disponibilidade_atendimento: "disponibilidade_atendimento__636ab4a0f0d91",
            valor_medio_mensal_da_conta: "valor_m__dio_mensal_da_conta_633c29221d7cc",
            clique_ver_ofertas_disponiveis: "clique_ver_ofertas_dispon__veis_647739e4342ab",
            engajamento_com_proposta_de_valor: "engajamento_com_proposta_de_valor__63245af1cb5cd"
        },
        bg_color_frame: null,
        cor_tema_primaria: "#2CA4AA",
        cor_tema_secundaria: "#2CA4AA",
        cor_tema_3: "#ABDBDD",
        cor_tema_4: "#ABDBDD",
        cor_tema_5: "#2CA4AA",
        cor_tema_botao_solido: "#2CA4AA",
        cor_texto_botao: "#FFFFFF",
        cor_tema_botao_desabilitado: "#F2F5F2",
        cor_tema_botao_borda_desabilitado: "#B6B8B7",
        botao_gradiente: null,
        cor_botao_icone: "#2CA4AA",
        cor_tema_botao_borda: "#2CA4AA",
        cor_hover_botao_borda: "#BDE8EA",
        cor_tema_step_default: "#2CA4AA",
        cor_ponta_inferior_lateral_esquerda: "#5DD0D5",
        consentimento_cookie_text: "Armazenamos cookies para melhorar sua experi\xeancia de navega\xe7\xe3o. Conheca nossa [[Pol\xedtica de Privacidade]]",
        code_tag_manager: "W845P7M5",
        logo_empresa: {
            data: {
                attributes: {
                    url: "/wl/voltta/logo_empresa.svg"
                }
            }
        },
        logo_empresa_2: {
            data: {
                attributes: {
                    url: "/wl/voltta/logo_empresa_2.svg"
                }
            }
        },
        logo_empresa_rodape: {
            data: {
                attributes: {
                    url: "/wl/voltta/logo_empresa_rodape.svg"
                }
            }
        },
        favicon: {
            data: {
                attributes: {
                    url: "/wl/voltta/favicon.svg"
                }
            }
        },
        bg_img_frame: {
            data: null
        },
        splash: {
            data: {
                attributes: {
                    url: "/wl/voltta/splash.gif"
                }
            }
        },
        card_esquerda: {
            data: {
                attributes: {
                    url: "/wl/voltta/card_esquerda.svg"
                }
            }
        },
        bg_img_redirect: {
            data: {
                attributes: {
                    url: "/wl/voltta/bg_img_redirect.png"
                }
            }
        },
        icone_whatsapp: {
            data: {
                attributes: {
                    url: "/wl/voltta/icone_whatsapp.svg"
                }
            }
        },
        icone_duvidas: {
            data: {
                attributes: {
                    url: "/wl/voltta/icone_duvidas.svg"
                }
            }
        },
        bg_img_manutencao: {
            data: {
                attributes: {
                    url: "/wl/voltta/bg_img_manutencao.svg"
                }
            }
        },
        bg_img_error_aplicacao: {
            data: {
                attributes: {
                    url: "/wl/voltta/bg_img_error_aplicacao.svg"
                }
            }
        },
        Onboarding: {
            header_color: false,
            titulo_bem_vindo: "Bem vindo a VOLTTA!",
            titulo_onboarding_1: "Por que a VOLTTA?",
            descricao_onboarding_1: "Voc\xea vai conhecer um novo jeito de consumir energia: mais barata, mais sustent\xe1vel, com mais liberdade de escolha e facilidade!",
            titulo_onboarding_2: "Energia na palma da sua m\xe3o",
            descricao_onboarding_2: "Escolha a usina parceira e o tipo de energia que ir\xe1 consumir na sua casa.  Economize na conta de luz e tenha uma atitude sustent\xe1vel.  ",
            titulo_onboarding_3: "Muito simples e seguro ",
            descricao_onboarding_3: "A contrata\xe7\xe3o \xe9 simples e segura. E n\xe3o se preocupe com falta de luz, pois voc\xea continuar\xe1 ligado ao fornecimento tradicional de energia.",
            titulo_onboarding_4: "Escolha o melhor para voc\xea ",
            descricao_onboarding_4: "Informe o seu consumo. A gente apresenta as possibilidades. Voc\xea assina o contrato e n\xf3s avisamos \xe0 usina e a sua distribuidora.",
            titulo_onboarding_5: "Economia o ano inteiro ",
            descricao_onboarding_5: "No final do ciclo de consumo, voc\xea vai passar a pagar duas contas mas, o valor total ser\xe1 at\xe9 25% menor do que aquele que voc\xea paga hoje. ",
            titulo_onboarding_6: "Fa\xe7a sua escolha",
            descricao_onboarding_6: "Chega de pagar caro por energia el\xe9trica! Seja sustent\xe1vel e economize. ",
            background_img: null,
            bg_img_onboarding_1: {
                data: {
                    attributes: {
                        url: "/wl/voltta/bg_img_onboarding_1.svg"
                    }
                }
            },
            bg_img_onboarding_2: {
                data: {
                    attributes: {
                        url: "/wl/voltta/bg_img_onboarding_2.svg"
                    }
                }
            },
            bg_img_onboarding_3: {
                data: {
                    attributes: {
                        url: "/wl/voltta/bg_img_onboarding_3.svg"
                    }
                }
            },
            bg_img_onboarding_4: {
                data: {
                    attributes: {
                        url: "/wl/voltta/bg_img_onboarding_4.svg"
                    }
                }
            },
            bg_img_onboarding_5: {
                data: {
                    attributes: {
                        url: "/wl/voltta/bg_img_onboarding_5.svg"
                    }
                }
            },
            bg_img_onboarding_6: {
                data: {
                    attributes: {
                        url: "/wl/voltta/bg_img_onboarding_6.svg"
                    }
                }
            }
        },
        Usuario: {
            bg_img_confirmacao_conta: {
                data: {
                    attributes: {
                        url: "/wl/voltta/bg_img_confirmacao_conta.svg"
                    }
                }
            },
            bg_img_email_enviado: {
                data: {
                    attributes: {
                        url: "/wl/voltta/bg_img_email_enviado.svg"
                    }
                }
            },
            bg_img_erro_link_invalido: {
                data: {
                    attributes: {
                        url: "/wl/voltta/bg_img_erro_link_invalido.svg"
                    }
                }
            },
            bg_img_password_reset: {
                data: {
                    attributes: {
                        url: "/wl/voltta/bg_img_password_reset.svg"
                    }
                }
            },
            bg_img_password_reset_success: {
                data: {
                    attributes: {
                        url: "/wl/voltta/bg_img_password_reset_success.svg"
                    }
                }
            },
            bg_img_reenviar_email: {
                data: {
                    attributes: {
                        url: "/wl/voltta/bg_img_reenviar_email.svg"
                    }
                }
            },
            bg_img_sem_conta: {
                data: {
                    attributes: {
                        url: "/wl/voltta/bg_img_sem_conta.svg"
                    }
                }
            }
        },
        Calculadora: {
            cor_botao_select: "#2CA4AA",
            texto_descricao_consumo: null,
            cor_hover_botao_icon: "#BDE8EA",
            habilitar_contrato_pf: true,
            habilitar_contrato_pj: true,
            habilitar_captura_fornecedor: false,
            texto_captura_fornecedor: null,
            bg_img_calculadora_success: {
                data: {
                    attributes: {
                        url: "/wl/voltta/bg_img_calculadora_success.svg"
                    }
                }
            },
            bg_img_calculadora_not_found: {
                data: {
                    attributes: {
                        url: "/wl/voltta/bg_img_calculadora_not_found.svg"
                    }
                }
            },
            titulo_sem_estoque: "Ah, que pena! A energia esgotou na sua regi\xe3o, devido a alta demanda.",
            descricao_sem_estoque: "Estamos trabalhando para ampliar a oferta de energia limpa e oferec\xea-la novamente em sua regi\xe3o. N\xe3o desanime! Enquanto isso, voc\xea est\xe1 em nossa lista de espera e vamos te mantendo atualizado de todas as novidades da VOLTTA.",
            img_sem_estoque: {
                data: {
                    attributes: {
                        url: "/wl/voltta/img_sem_estoque.svg"
                    }
                }
            },
            titulo_nao_atendida: "Ah, que pena! No momento, n\xe3o temos energia dispon\xedvel na sua regi\xe3o. ",
            descricao_nao_atendida: "Estamos trabalhando para, em breve, oferecer energia limpa e mais barata para voc\xea e todo Brasil. N\xe3o desanime! Enquanto isso, voc\xea est\xe1 em nossa lista de espera e vamos te mantendo atualizado de todas as novidades da VOLTTA.\nAgradecemos a sua compreens\xe3o e ficamos felizes pelo seu interesse em contribuir para um planeta mais sustent\xe1vel!",
            img_nao_atendida: {
                data: {
                    attributes: {
                        url: "/wl/voltta/img_nao_atendida.svg"
                    }
                }
            },
            img_form_fornecedor: {
                data: null
            },
            img_sem_consumo_minimo: {
                data: {
                    attributes: {
                        url: "/wl/voltta/img_sem_consumo_minimo.svg"
                    }
                }
            }
        },
        Coleta_Dados_Usuario: {
            bg_img_code_sms: {
                data: {
                    attributes: {
                        url: "/wl/voltta/bg_img_code_sms.svg"
                    }
                }
            },
            bg_img_confirmacao_dados_confirmacao_sms: {
                data: {
                    attributes: {
                        url: "/wl/voltta/bg_img_confirmacao_dados_confirmacao_sms.svg"
                    }
                }
            },
            bg_img_localizacao: {
                data: {
                    attributes: {
                        url: "/wl/voltta/bg_img_localizacao.png"
                    }
                }
            },
            bg_img_localizacao_nao_encontrado: {
                data: {
                    attributes: {
                        url: "/wl/voltta/bg_img_localizacao_nao_encontrado.png"
                    }
                }
            }
        },
        Formulario: {
            bg_img_form: {
                data: {
                    attributes: {
                        url: "/wl/voltta/bg_img_form.svg"
                    }
                }
            },
            bg_img_form_confirmacao: {
                data: {
                    attributes: {
                        url: "/wl/voltta/bg_img_form_confirmacao.png"
                    }
                }
            },
            bg_img_tooltip_form: {
                data: {
                    attributes: {
                        url: "/wl/voltta/bg_img_tooltip_form.png"
                    }
                }
            }
        },
        Pessoa_Fisica: {
            Step_1: {
                bg_img_dados_nao_encontrados: {
                    data: {
                        attributes: {
                            url: "/wl/voltta/bg_img_dados_nao_encontrados.png"
                        }
                    }
                },
                bg_img_dados_pessoais: {
                    data: {
                        attributes: {
                            url: "/wl/voltta/bg_img_dados_pessoais.svg"
                        }
                    }
                }
            },
            Step_2: {
                bg_img_confirme_dados_endereco: {
                    data: {
                        attributes: {
                            url: "/wl/voltta/bg_img_confirme_dados_endereco.png"
                        }
                    }
                },
                bg_img_endereco: {
                    data: {
                        attributes: {
                            url: "/wl/voltta/bg_img_endereco.png"
                        }
                    }
                }
            },
            Step_3: {
                bg_img_rg: {
                    data: {
                        attributes: {
                            url: "/wl/voltta/bg_img_rg.png"
                        }
                    }
                },
                bg_img_tooltip_rg: {
                    data: {
                        attributes: {
                            url: "/wl/voltta/bg_img_tooltip_rg.png"
                        }
                    }
                },
                bg_img_documento_adicionado: {
                    data: {
                        attributes: {
                            url: "/wl/voltta/bg_img_documento_adicionado.svg"
                        }
                    }
                }
            },
            Step_4: {
                bg_img_conta_luz: {
                    data: {
                        attributes: {
                            url: "/wl/voltta/bg_img_conta_luz.png"
                        }
                    }
                },
                bg_img_tooltip_conta_luz: {
                    data: {
                        attributes: {
                            url: "/wl/voltta/bg_img_tooltip_conta_luz.png"
                        }
                    }
                },
                bg_img_conta_luz_adicionada: {
                    data: {
                        attributes: {
                            url: "/wl/voltta/bg_img_conta_luz_adicionada.svg"
                        }
                    }
                }
            },
            Step_5: {
                bg_img_confirmacao_conta: {
                    data: {
                        attributes: {
                            url: "/wl/voltta/bg_img_confirmacao_conta.svg"
                        }
                    }
                }
            }
        },
        Pessoa_Juridica: {
            Step_1_pj: {
                bg_img_contrado_social_pj: {
                    data: {
                        attributes: {
                            url: "/wl/voltta/bg_img_contrado_social_pj.png"
                        }
                    }
                },
                bg_img_tooltip_contrado_social_pj: {
                    data: {
                        attributes: {
                            url: "/wl/voltta/bg_img_tooltip_contrado_social_pj.png"
                        }
                    }
                },
                bg_img_vamos_comecar_pj: {
                    data: {
                        attributes: {
                            url: "/wl/voltta/bg_img_vamos_comecar_pj.png"
                        }
                    }
                },
                bg_img_dados_empresa_pj: {
                    data: {
                        attributes: {
                            url: "/wl/voltta/bg_img_dados_empresa_pj.png"
                        }
                    }
                },
                bg_img_contrado_social_adicionado_pj: {
                    data: {
                        attributes: {
                            url: "/wl/voltta/bg_img_contrado_social_adicionado_pj.svg"
                        }
                    }
                },
                bg_img_confirme_dados_empresa_pj: {
                    data: {
                        attributes: {
                            url: "/wl/voltta/bg_img_confirme_dados_empresa_pj.svg"
                        }
                    }
                },
                bg_img_possui_demanda_pj: {
                    data: {
                        attributes: {
                            url: "/wl/voltta/bg_img_possui_demanda_pj.png"
                        }
                    }
                },
                bg_img_tooltip_possui_demanda_pj: {
                    data: {
                        attributes: {
                            url: "/wl/voltta/bg_img_tooltip_possui_demanda_pj.png"
                        }
                    }
                }
            },
            Step_2_pj: {
                bg_img_rg_pj: {
                    data: {
                        attributes: {
                            url: "/wl/voltta/bg_img_rg_pj.png"
                        }
                    }
                },
                bg_img_tooltip_rg_pj: {
                    data: {
                        attributes: {
                            url: "/wl/voltta/bg_img_tooltip_rg_pj.png"
                        }
                    }
                }
            },
            Step_3_pj: {
                bg_img_conta_luz_pj: {
                    data: {
                        attributes: {
                            url: "/wl/voltta/bg_img_conta_luz_pj.png"
                        }
                    }
                },
                bg_img_tooltip_conta_luz_pj: {
                    data: {
                        attributes: {
                            url: "/wl/voltta/bg_img_tooltip_conta_luz_pj.png"
                        }
                    }
                },
                bg_img_conta_luz_adicionada_pj: {
                    data: {
                        attributes: {
                            url: "/wl/voltta/bg_img_conta_luz_adicionada_pj.svg"
                        }
                    }
                }
            },
            Step_4_pj: {
                bg_img_dados_submetidos_pj: {
                    data: {
                        attributes: {
                            url: "/wl/voltta/bg_img_dados_submetidos_pj.png"
                        }
                    }
                }
            }
        },
        Email: {
            bg_img_confirmacao_conta: {
                data: {
                    attributes: {
                        url: "/wl/voltta/bg_img_email_confirmacao_conta.svg"
                    }
                }
            },
            bg_img_contrato_assinado: {
                data: {
                    attributes: {
                        url: "/wl/voltta/img_contrato_assinado.svg"
                    }
                }
            }
        },
        Mercado_Livre: {
            bg_img_sucesso_solicitacao_contato: {
                data: {
                    attributes: {
                        url: "/wl/voltta/bg_img_sucesso_solicitacao_contato.svg"
                    }
                }
            },
            bg_img_conta_luz_ml: {
                data: {
                    attributes: {
                        url: "/wl/voltta/bg_img_conta_luz_ml.png"
                    }
                }
            },
            bg_img_tooltip_conta_luz_ml: {
                data: {
                    attributes: {
                        url: "/wl/voltta/bg_img_tooltip_conta_luz_ml.png"
                    }
                }
            },
            bg_img_conta_luz_adicionada_ml: {
                data: {
                    attributes: {
                        url: "/wl/voltta/bg_img_conta_luz_adicionada_ml.svg"
                    }
                }
            },
            entenda_porque_1: {
                data: {
                    attributes: {
                        url: "/wl/voltta/entenda_porque_1.gif"
                    }
                }
            },
            bg_img_contrato_social_adicionado_ml: {
                data: {
                    attributes: {
                        url: "/wl/voltta/bg_img_contrato_social_adicionado_ml.svg"
                    }
                }
            },
            bg_img_documento_adicionado_ml: {
                data: {
                    attributes: {
                        url: "/wl/voltta/bg_img_documento_adicionado_ml.svg"
                    }
                }
            },
            bg_img_contrato_social_ml: {
                data: {
                    attributes: {
                        url: "/wl/voltta/bg_img_contrato_social_ml.png"
                    }
                }
            },
            bg_img_tooltip_contrado_social: {
                data: {
                    attributes: {
                        url: "/wl/voltta/bg_img_tooltip_contrado_social.png"
                    }
                }
            },
            bg_img_tooltip_documento_ml: {
                data: {
                    attributes: {
                        url: "/wl/voltta/bg_img_tooltip_documento_ml.png"
                    }
                }
            },
            bg_img_documento_ml: {
                data: {
                    attributes: {
                        url: "/wl/voltta/bg_img_documento_ml.png"
                    }
                }
            }
        },
        Zapsign: {
            bg_img_assinatura_contrato: {
                data: {
                    attributes: {
                        url: "/wl/voltta/bg_img_assinatura_contrato.svg"
                    }
                }
            },
            bg_img_contrato_assinado: {
                data: {
                    attributes: {
                        url: "/wl/voltta/bg_img_contrato_assinado.png"
                    }
                }
            }
        }
    }
};


/***/ }),

/***/ 89368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ COOKIES_TAGS; }
/* harmony export */ });
var COOKIES_TAGS = {
    USER_EMAIL: "electy-server@user-email",
    SIMULACAO_DATA: "electy-server@simulacao-data",
    LEAD_ID: "electy-server@lead-id"
};


/***/ }),

/***/ 66283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47041);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(cookies_next__WEBPACK_IMPORTED_MODULE_1__);


var ConfiguredAppAxiosWithCtx = function(appAxios, reqRes) {
    var appAxiosCtx;
    if (reqRes) {
        var ref;
        var result = (0,cookies_next__WEBPACK_IMPORTED_MODULE_1__.getCookie)("electy-server@auth-token", reqRes);
        var token = (ref = JSON.parse(result)) === null || ref === void 0 ? void 0 : ref.token;
        appAxiosCtx = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
            baseURL: "https://cms.electy.com.br/api/",
            timeout: 10000,
            // withCredentials: true,
            headers: {
                "Content-Type": "application/json"
            }
        });
        appAxiosCtx.interceptors.request.use(function(config) {
            try {
                var ref;
                var user = (0,cookies_next__WEBPACK_IMPORTED_MODULE_1__.getCookie)("electy-server@auth-token", reqRes);
                var token = (ref = JSON.parse(user)) === null || ref === void 0 ? void 0 : ref.token;
                if (token) {
                    config.headers["Authorization"] = "Bearer ".concat(token);
                }
            } catch (error) {
                console.log("not token");
            }
            return config;
        });
    } else {
        appAxiosCtx = appAxios;
    }
    return appAxiosCtx;
};
/* harmony default export */ __webpack_exports__["Z"] = (ConfiguredAppAxiosWithCtx);


/***/ }),

/***/ 85325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cl": function() { return /* binding */ appMultPartFormAxios; },
/* harmony export */   "S0": function() { return /* binding */ appAxios; },
/* harmony export */   "Vm": function() { return /* binding */ nextApiAxios; }
/* harmony export */ });
/* unused harmony exports appMultPartFormAxiosBase, nextApiMultPartAxios, consultaCnpj, consultaCpf */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62286);
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(nookies__WEBPACK_IMPORTED_MODULE_2__);
/* provided dependency */ var process = __webpack_require__(34155);



// import { getCookie } from "cookies-next";


var appAxiosBase = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: "https://cms.electy.com.br/api/",
    timeout: 10000,
    // withCredentials: true,
    headers: {
        "Content-Type": "application/json"
    }
});
// Interceptação para funcionar apenas em useEffect, ou chamadas dentro do react
// Para chamadas em ServerSide, por falta de context e request, não será possível
// capturar os cookies, e portanto não validará o token
appAxiosBase.interceptors.request.use(function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(config) {
        var originalHeaders, ref, req, ref1, user, token;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            originalHeaders = config.headers;
            try {
                ;
                req = config.request;
                ref1 = (0,nookies__WEBPACK_IMPORTED_MODULE_2__.parseCookies)(), user = ref1["electy-server@auth-token"];
                token = (ref = JSON.parse(user)) === null || ref === void 0 ? void 0 : ref.token;
                // const res = config.response
                // const user = parseCookies(config.headers, 'electy-server@auth-token')
                // console.log(user, config.headers, 'USER!')
                // const {'electy@token': token} = parseCookies()
                if (token) {
                    config.headers["Authorization"] = "Bearer ".concat(token);
                    if (config.url != "users/me") {
                        appAxiosBase.get("users/me").then(function(data) {
                            return data;
                        }).catch(function(data) {
                            if (data.response.status == 403 || data.response.status == 401) {
                                next_router__WEBPACK_IMPORTED_MODULE_1___default().push("/usuario/logout");
                                return Promise.reject("expired");
                            }
                        });
                    }
                }
            } catch (error) {
                config.headers = originalHeaders;
                console.log(error.message, "appAxiosService.catch");
            }
            return [
                2,
                config
            ];
        });
    });
    return function(config) {
        return _ref.apply(this, arguments);
    };
}());
var appAxios = appAxiosBase;
var appMultPartFormAxiosBase = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: "https://cms.electy.com.br/api/",
    timeout: 10000,
    headers: {
        "Content-Type": "multipart/form-data"
    }
});
// Interceptação para funcionar apenas em useEffect, ou chamadas dentro do react
// Para chamadas em ServerSide, por falta de context e request, não será possível
// capturar os cookies, e portanto não validará o token
appMultPartFormAxiosBase.interceptors.request.use(function(config) {
    var originalHeaders = config.headers;
    try {
        var ref = (0,nookies__WEBPACK_IMPORTED_MODULE_2__.parseCookies)(), user = ref["electy-server@auth-token"];
        var token = JSON.parse(user).token;
        // const {'electy@token': token} = parseCookies()
        if (token) {
            config.headers["Authorization"] = "Bearer ".concat(token);
        }
        if (config.url != "users/me") {
            appAxiosBase.get("users/me").then(function(data) {
                return data;
            }).catch(function(data) {
                // if(data.response.status == 403 || data.response.status == 401) {
                next_router__WEBPACK_IMPORTED_MODULE_1___default().push("/usuario/logout");
                return Promise.reject("expired");
            // }
            });
        }
    } catch (error) {
        config.headers = originalHeaders;
    }
    return config;
});
var appMultPartFormAxios = appMultPartFormAxiosBase;
var nextApiAxios = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: "/api/",
    timeout: 10000,
    headers: {
        "Content-Type": "application/json"
    }
});
var nextApiMultPartAxios = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: "/api/",
    timeout: 10000,
    headers: {
        "Content-Type": "multipart/form-data"
    }
});
var consultaCnpj = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(cnpj) {
        var consultarCNPJ;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    consultarCNPJ = __webpack_require__(6296);
                    return [
                        4,
                        consultarCNPJ(cnpj, process.env.SECRECT_API_CONSULTA_CNPJ_TOKEN).then(function(data) {
                            var ref;
                            if (((ref = data.estabelecimento) === null || ref === void 0 ? void 0 : ref.situacao_cadastral) == "Ativa") {
                                return {
                                    status: true,
                                    nome: data.razao_social
                                };
                            }
                            return {
                                status: false,
                                msg: "nao_encontrado"
                            };
                        }).catch(function(err) {
                            return {
                                status: false,
                                msg: "api_error"
                            };
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function consultaCnpj(cnpj) {
        return _ref.apply(this, arguments);
    };
}();
var consultaCpf = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(cpf, birthdate) {
        var url, token;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = process.env.SECRECT_API_CONSULTA_CPF_URL;
                    token = process.env.SECRECT_API_CONSULTA_CPF_TOKEN;
                    return [
                        4,
                        fetch("".concat(url, "/cpf?token=").concat(token, "&timeout=600&cpf=").concat(cpf, "&birthdate=").concat(birthdate, "&origem=web")).then(function(data) {
                            return data.json();
                        }).then(function(data) {
                            // console.log('CPF - - -', {data})
                            if (data.data.length > 0) {
                                data = data.data[0];
                            }
                            if ((data === null || data === void 0 ? void 0 : data.situacao_cadastral) == "REGULAR") {
                                return {
                                    status: true,
                                    message: "OK",
                                    nome: data === null || data === void 0 ? void 0 : data.nome_fantasia
                                };
                            }
                            if (data.code == 603) {
                                console.log("API de valida\xe7\xe3o do CPF n\xe3o est\xe1 funcionando");
                                return {
                                    status: true,
                                    message: "OK"
                                };
                            }
                            return {
                                status: false,
                                msg: "nao_encontrado"
                            };
                        }).catch(function(err) {
                            return {
                                status: false,
                                msg: "api_error"
                            };
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function consultaCpf(cpf, birthdate) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 8783:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64487);
/* provided dependency */ var process = __webpack_require__(34155);


var secretApiAxios = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: process.env.SECRET_APP_API_URL,
    timeout: 10000,
    headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer ".concat(process.env.SECRET_APP_API_TOKEN)
    }
});
secretApiAxios.interceptors.response.use(function(response) {
    // Qualquer código de status 2xx faz com que esta função seja acionada
    return response;
}, function(error) {
    error.message = "[STRAPI] - " + error.message;
    _sentry_nextjs__WEBPACK_IMPORTED_MODULE_1__/* .captureException */ .Tb(error);
    return Promise.reject(error);
});
/* harmony default export */ __webpack_exports__["Z"] = (secretApiAxios);


/***/ }),

/***/ 22912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ GetInfos; },
/* harmony export */   "w": function() { return /* binding */ GetInformationService; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var _functions_getConfiguredAppAxiosWithCtx__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66283);
/* harmony import */ var _core_appAxiosService__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85325);
/* harmony import */ var _core_secretApiAxios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8783);





var GetInformationService = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(ctx) {
        var appAxiosCtx;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    appAxiosCtx = (0,_functions_getConfiguredAppAxiosWithCtx__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_core_appAxiosService__WEBPACK_IMPORTED_MODULE_1__/* .appAxios */ .S0, ctx);
                    return [
                        4,
                        appAxiosCtx.get("infos", {}).then(function(data) {
                            return data.data;
                        }).catch(function(err) {
                            return {
                                error: "Erro de comunica\xe7\xe3o"
                            };
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function GetInformationService(ctx) {
        return _ref.apply(this, arguments);
    };
}();
var GetInfos = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _core_secretApiAxios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("infos?populate=*").then(function(data) {
                            return data.data;
                        }).catch(function(err) {
                            return {
                                error: "Erro de comunica\xe7\xe3o",
                                err: err
                            };
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function GetInfos() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 31989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": function() { return /* binding */ DispathHookUpdate; },
  "x": function() { return /* binding */ fluxUpdate; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./src/services/endpoints/information/GetInformationService.js
var GetInformationService = __webpack_require__(22912);
// EXTERNAL MODULE: ./src/services/logs/set-log.js
var set_log = __webpack_require__(38479);
// EXTERNAL MODULE: ./src/services/hooks/pipefy/src/get-query.js
var get_query = __webpack_require__(54967);
;// CONCATENATED MODULE: ./src/services/hooks/pipefy/src/pipe-request.js



function pipeRequest(_) {
    return _pipeRequest.apply(this, arguments);
}
function _pipeRequest() {
    _pipeRequest = (0,_async_to_generator/* default */.Z)(function(param) {
        var query, config, response, json, err;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    query = param.query, config = param.config;
                    return [
                        4,
                        fetch(config === null || config === void 0 ? void 0 : config.pipeUrl, {
                            //HTTP Request
                            method: "POST",
                            headers: {
                                accept: "application/json",
                                "Authorization": "Bearer ".concat(config === null || config === void 0 ? void 0 : config.pipeToken),
                                "Content-type": "application/json; charset=UTF-8"
                            },
                            body: JSON.stringify({
                                query: query
                            })
                        })
                    ];
                case 1:
                    response = _state.sent();
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        response.json()
                    ];
                case 3:
                    json = _state.sent();
                    if ((json === null || json === void 0 ? void 0 : json.errors) && json.errors.length > 0) {
                        (0,set_log/* SetLog */.J)(set_log/* TagLogs.error_details_dispath_hook_update */.w.error_details_dispath_hook_update, {
                            data: {
                                query: query,
                                error: json
                            }
                        }, false);
                    }
                    return [
                        3,
                        5
                    ];
                case 4:
                    err = _state.sent();
                    console.log(err.message, "aaa");
                    (0,set_log/* SetLog */.J)(set_log/* TagLogs.error_query_dispath_hook_update */.w.error_query_dispath_hook_update, {
                        data: {
                            query: query,
                            error: err.message
                        }
                    }, false);
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2,
                        json
                    ];
            }
        });
    });
    return _pipeRequest.apply(this, arguments);
}

// EXTERNAL MODULE: ./src/services/endpoints/core/secretApiAxios.js
var secretApiAxios = __webpack_require__(8783);
// EXTERNAL MODULE: ./src/services/wl/index.js + 2 modules
var services_wl = __webpack_require__(67057);
;// CONCATENATED MODULE: ./src/services/hooks/pipefy/src/create-card.js







function createCard(_) {
    return _createCard.apply(this, arguments);
}
function _createCard() {
    _createCard = (0,_async_to_generator/* default */.Z)(function(param) {
        var data, config, emailAddress, wl, dataQuery, query, json;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    data = param.data, config = param.config, emailAddress = param.emailAddress;
                    return [
                        4,
                        (0,services_wl/* GetWLData */.B)()
                    ];
                case 1:
                    wl = _state.sent();
                    return [
                        4,
                        (0,get_query/* getQueryString */.W)(data, "create", config.pipeType)
                    ];
                case 2:
                    dataQuery = _state.sent();
                    query = "mutation{createCard(input:{pipe_id: ".concat(config.pipeId, ",phase_id: ").concat(config.phaseId, ",fields_attributes: [").concat(dataQuery, "]}){clientMutationId card{id}}}");
                    return [
                        4,
                        pipeRequest({
                            query: query,
                            config: config
                        })
                    ];
                case 3:
                    json = _state.sent();
                    return [
                        2,
                        json
                    ];
            }
        });
    });
    return _createCard.apply(this, arguments);
}

;// CONCATENATED MODULE: ./src/services/hooks/pipefy/src/find-card.js



function findCardByEmail(_) {
    return _findCardByEmail.apply(this, arguments);
}
function _findCardByEmail() {
    _findCardByEmail = (0,_async_to_generator/* default */.Z)(function(param) {
        var emailAddress, config, query, result;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    emailAddress = param.emailAddress, config = param.config;
                    query = "query {findCards(pipeId: ".concat(config.pipeId, ' search:{fieldId: "email", fieldValue: "').concat(emailAddress, '"}) {edges{node{id fields { field{id} value array_value }}}}}');
                    return [
                        4,
                        pipeRequest({
                            query: query,
                            config: config
                        })
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return _findCardByEmail.apply(this, arguments);
}
function findCardByPipeId(_) {
    return _findCardByPipeId.apply(this, arguments);
}
function _findCardByPipeId() {
    _findCardByPipeId = (0,_async_to_generator/* default */.Z)(function(param) {
        var pipeId, config, query, result;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    pipeId = param.pipeId, config = param.config;
                    query = "query { card(id: ".concat(parseInt(pipeId), ") { id title fields { value field {id} array_value} }}");
                    return [
                        4,
                        pipeRequest({
                            query: query,
                            config: config
                        })
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return _findCardByPipeId.apply(this, arguments);
}

;// CONCATENATED MODULE: ./src/services/hooks/pipefy/src/update-card.js




function updateCard(_) {
    return _updateCard.apply(this, arguments);
}
function _updateCard() {
    _updateCard = (0,_async_to_generator/* default */.Z)(function(param) {
        var oldLead, data, config, ref, dataQuery, _id, id, query, json;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    oldLead = param.oldLead, data = param.data, config = param.config;
                    return [
                        4,
                        (0,get_query/* getQueryString */.W)(data, "update", config.pipeType, oldLead.fields)
                    ];
                case 1:
                    dataQuery = _state.sent();
                    id = (_id = oldLead.id) !== null && _id !== void 0 ? _id : (ref = oldLead.node) === null || ref === void 0 ? void 0 : ref.id;
                    query = "mutation{updateFieldsValues(input:{nodeId:".concat(id, ",values:[").concat(dataQuery, "]}){success updatedNode{__typename}}}");
                    return [
                        4,
                        pipeRequest({
                            query: query,
                            config: config
                        })
                    ];
                case 2:
                    json = _state.sent();
                    return [
                        2,
                        json
                    ];
            }
        });
    });
    return _updateCard.apply(this, arguments);
}

;// CONCATENATED MODULE: ./src/services/hooks/pipefy/src/save-card.js





/**
 * Central de operações no card
 */ function saveCard(_) {
    return _saveCard.apply(this, arguments);
}
function _saveCard() {
    _saveCard = (0,_async_to_generator/* default */.Z)(function(param) {
        var params, config, ref, ref1, ref2, ref3, data, emailAddress, pipeId, json, oldLead, ref4, ref5, ref6, ref7, result;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = param.params, config = param.config;
                    data = (ref3 = params === null || params === void 0 ? void 0 : params.body) !== null && ref3 !== void 0 ? ref3 : params;
                    emailAddress = params.userEmail;
                    pipeId = data === null || data === void 0 ? void 0 : data.pipe_id;
                    if (!pipeId) return [
                        3,
                        2
                    ];
                    console.log("FINDBYPIPEID");
                    return [
                        4,
                        findCardByPipeId({
                            pipeId: pipeId,
                            config: config
                        })
                    ];
                case 1:
                    json = _state.sent();
                    oldLead = (ref4 = json.data) === null || ref4 === void 0 ? void 0 : ref4.card;
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        findCardByEmail({
                            emailAddress: emailAddress,
                            config: config
                        })
                    ];
                case 3:
                    json = _state.sent();
                    oldLead = (ref5 = json.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.findCards) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.edges) === null || ref7 === void 0 ? void 0 : ref7[0];
                    _state.label = 4;
                case 4:
                    if (!(oldLead == null)) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        createCard({
                            data: data,
                            config: config,
                            emailAddress: emailAddress
                        })
                    ];
                case 5:
                    result = _state.sent();
                    return [
                        3,
                        8
                    ];
                case 6:
                    return [
                        4,
                        updateCard({
                            oldLead: oldLead,
                            data: data,
                            config: config
                        })
                    ];
                case 7:
                    result = _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        2,
                        {
                            status: !((result === null || result === void 0 ? void 0 : (ref = result.errors) === null || ref === void 0 ? void 0 : ref.length) > 0 || (result === null || result === void 0 ? void 0 : (ref1 = result.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.errors) === null || ref2 === void 0 ? void 0 : ref2.length) > 0),
                            data: result === null || result === void 0 ? void 0 : result.data
                        }
                    ];
            }
        });
    });
    return _saveCard.apply(this, arguments);
}

;// CONCATENATED MODULE: ./src/services/hooks/pipefy/SendPipeData.js




function SendPipeData(params) {
    return _SendPipeData.apply(this, arguments);
} // Listar fases
 // {
 //   pipe(id:303870166){
 //     phases{
 //       name
 //       id
 //     }
 //   }
 // }
 // Move card de fase
 // mutation{
 //   moveCardToPhase(input:{
 //     card_id: 1,
 //     destination_phase_id: 1
 //   }){
 //     clientMutationId
 //   }
 // }
function _SendPipeData() {
    _SendPipeData = (0,_async_to_generator/* default */.Z)(function(params) {
        var ref, ref1, ref2, infos, config, result;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,GetInformationService/* GetInfos */.B)()
                    ];
                case 1:
                    infos = (ref = _state.sent()) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.attributes;
                    config = {
                        pipeId: infos.api_pipefy_pipeid_lead_data,
                        phaseId: infos.api_pipefy_fase_lead_data,
                        pipeToken: infos.api_pipefy_key,
                        pipeUrl: infos.api_pipefy_url,
                        pipeType: "data"
                    };
                    return [
                        4,
                        saveCard({
                            params: params,
                            config: config
                        })
                    ];
                case 2:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return _SendPipeData.apply(this, arguments);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next-session/lib/session.js + 4 modules
var lib_session = __webpack_require__(12822);
;// CONCATENATED MODULE: ./src/services/hooks/sharpspring/SendSharp.js
/* provided dependency */ var process = __webpack_require__(34155);







function SendSharp() {
    return _SendSharp.apply(this, arguments);
}
function _SendSharp() {
    _SendSharp = (0,_async_to_generator/* default */.Z)(function() {
        var params, result, userEmail, body, req, res, sharp, arraySharpKeys, acceptKeys, bodyKeys, acceptedKeys, lead, sharpUri, getSession, session, beforeLead, method, ref;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : false;
                    userEmail = params.userEmail;
                    body = params.body;
                    req = params.req || {};
                    res = params.res || {};
                    if (!userEmail) {
                        (0,set_log/* SetLog */.J)(set_log/* TagLogs.error_sharpspring */.w.error_sharpspring, {
                            params: params,
                            details: "params.userEmail undefined"
                        }, false);
                        return [
                            2,
                            false
                        ];
                    }
                    if (!body) {
                        (0,set_log/* SetLog */.J)(set_log/* TagLogs.error_sharpspring */.w.error_sharpspring, {
                            params: params,
                            details: "params.body undefined"
                        }, false);
                        return [
                            2,
                            false
                        ];
                    }
                    return [
                        4,
                        (0,services_wl/* GetWLData */.B)({
                            keyName: "config_campos_sharpspring"
                        })
                    ];
                case 1:
                    sharp = _state.sent();
                    arraySharpKeys = sharp.data.config_campos_sharpspring;
                    body = Object.fromEntries(Object.entries(body).filter(function(param) {
                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                        return key !== "";
                    }));
                    acceptKeys = Object.keys(arraySharpKeys);
                    bodyKeys = Object.keys(body);
                    acceptedKeys = bodyKeys.filter(function(item) {
                        return acceptKeys.includes(item);
                    });
                    lead = {};
                    acceptedKeys.forEach(function(item) {
                        lead[arraySharpKeys[item]] = body[item];
                    });
                    // Bloquear envio de dados para sharpspring em developer emails
                    if (process.env.BLOCK_SHARP_WITH_BLACK_LIST_EMAILS == 1 && process.env.BLACK_LIST_EMAILS.split(",").includes(userEmail)) {
                        return [
                            2,
                            {
                                status: true,
                                message: "developer_runnig",
                                lead: lead
                            }
                        ];
                    }
                    sharpUri = "".concat(process.env.SECRET_SHARPSPRING_API_URI);
                    sharpUri += "?accountID=".concat(process.env.SECRET_SHARPSPRING_API_ACCOUNT_ID);
                    sharpUri += "&secretKey=".concat(process.env.SECRET_SHARPSPRING_API_SECRET_KEY);
                    getSession = (0,lib_session/* default */.Z)();
                    return [
                        4,
                        getSession(req, res)
                    ];
                case 2:
                    session = _state.sent();
                    return [
                        4,
                        axios_default().post(sharpUri, {
                            method: "getLeads",
                            params: {
                                where: {
                                    emailAddress: [
                                        userEmail
                                    ]
                                },
                                limit: 1,
                                offset: 0
                            },
                            id: session.id
                        }).then(function(data) {
                            var ref, ref1;
                            return (ref = data.data) === null || ref === void 0 ? void 0 : (ref1 = ref.result) === null || ref1 === void 0 ? void 0 : ref1.lead;
                        })
                    ];
                case 3:
                    beforeLead = _state.sent();
                    // // atribuindo proprietário do lead
                    // if(process.env.SECRET_SHARPSPRING_OWNERID) {
                    // 	lead.ownerID = process.env.SECRET_SHARPSPRING_OWNERID
                    // }
                    if (((ref = beforeLead === null || beforeLead === void 0 ? void 0 : beforeLead.length) !== null && ref !== void 0 ? ref : 0) > 0) {
                        // Update Lead
                        method = "updateLeads";
                        lead.id = beforeLead[0].id;
                    } else {
                        // Create Lead
                        method = "createLeads";
                        lead.emailAddress = userEmail;
                    }
                    // clique_cta_usina_listing
                    // clique_cta1_card_usina
                    // clique_cta2_card_usina
                    lead = configureCheckedInputsInLead(lead, beforeLead, arraySharpKeys.clique_cta_usina_listing);
                    lead = configureCheckedInputsInLead(lead, beforeLead, arraySharpKeys.clique_cta1_card_usina);
                    lead = configureCheckedInputsInLead(lead, beforeLead, arraySharpKeys.clique_cta2_card_usina);
                    return [
                        4,
                        axios_default().post(sharpUri, {
                            method: method,
                            params: {
                                objects: [
                                    lead
                                ]
                            },
                            id: session.id
                        }).then(function(data) {
                            // console.log({data: data.data})
                            return true;
                        }).catch(function(err) {
                            console.log({
                                errorSharp: err.message
                            });
                            return false;
                        })
                    ];
                case 4:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return _SendSharp.apply(this, arguments);
}
/**
 * Configura o lead na sharp para campos Check, sem gravar dados repetidos
 * @returns lead
 */ var configureCheckedInputsInLead = function(lead, beforeLead, key) {
    // Verifica se o valor está setado
    if (lead === null || lead === void 0 ? void 0 : lead[key]) {
        var ref, ref1;
        // Garante que o card não seja inserido mais de uma vez
        if (!(beforeLead === null || beforeLead === void 0 ? void 0 : (ref = beforeLead[0]) === null || ref === void 0 ? void 0 : (ref1 = ref[key]) === null || ref1 === void 0 ? void 0 : ref1.includes(lead[key]))) {
            var ref2;
            // Adiciona o item na lista: caso seja o primeiro item, iniciará com ", " -- (sendo removido no próximo item)
            var sharpUsinaListClicked = "".concat(beforeLead === null || beforeLead === void 0 ? void 0 : (ref2 = beforeLead[0]) === null || ref2 === void 0 ? void 0 : ref2[key], ", ").concat(lead[key]);
            // Caso seja o primeiro item, precisa ser atribuído o valor direto, para não ficar iniciando com ", "
            if (!sharpUsinaListClicked.startsWith(", ")) {
                lead[key] = sharpUsinaListClicked;
            }
        } else {
            delete lead[key];
        }
    }
    return lead;
};

// EXTERNAL MODULE: ./src/services/v2/leads/index.js
var leads = __webpack_require__(39671);
;// CONCATENATED MODULE: ./src/services/v2/lead-integration/core/config-requests.js

function getIntegrationServiceAxios(dataConfig) {
    var api = axios_default().create({
        baseURL: dataConfig.integration_services_api_url,
        timeout: 10000,
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: "Bearer ".concat(dataConfig.integration_services_api_token)
        }
    });
    return api;
}

;// CONCATENATED MODULE: ./src/services/v2/lead-integration/core/get-api-results.js

function getApiStatusError(message, data) {
    (0,set_log/* SetLog */.J)(set_log/* TagLogs.error_dispath_hook_update */.w.error_dispath_hook_update, {
        msg: message,
        data: data
    }, false);
    return {
        status: false,
        message: message !== null && message !== void 0 ? message : [],
        data: data !== null && data !== void 0 ? data : []
    };
}
function getApiStatusSuccess(message, data) {
    return {
        status: true,
        message: message !== null && message !== void 0 ? message : [],
        data: data !== null && data !== void 0 ? data : []
    };
}
function getErrorMessageFromError(error) {
    var ref, ref1;
    var errorMessage = (err === null || err === void 0 ? void 0 : err.message) || (err === null || err === void 0 ? void 0 : (ref = err.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) || "Erro desconhecido";
    return errorMessage;
}

;// CONCATENATED MODULE: ./src/services/v2/lead-integration/core/get-infos.js



function getInfos() {
    return _getInfos.apply(this, arguments);
}
function _getInfos() {
    _getInfos = (0,_async_to_generator/* default */.Z)(function() {
        var ref, infos;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,GetInformationService/* GetInfos */.B)().then(function(result) {
                            var ref1, ref2;
                            return (ref = result === null || result === void 0 ? void 0 : (ref1 = result.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.attributes) !== null && ref !== void 0 ? ref : false;
                        })
                    ];
                case 1:
                    infos = _state.sent();
                    if (!infos) {
                        throw new Error("infos_not_found");
                    }
                    if (!infos.integration_services_api_enabled) {
                        throw new Error("disabled");
                    }
                    if (!infos.integration_services_api_url || !infos.integration_services_api_token || !infos.integration_services_api_key || !infos.integration_services_api_lead_route) {
                        throw new Error("api_configuration_error");
                    }
                    return [
                        2,
                        infos
                    ];
            }
        });
    });
    return _getInfos.apply(this, arguments);
}

;// CONCATENATED MODULE: ./src/services/v2/lead-integration/core/send-lead-integration-service.js






function sendLeadIntegrationService(leadData, currentLead) {
    return _sendLeadIntegrationService.apply(this, arguments);
}
function _sendLeadIntegrationService() {
    _sendLeadIntegrationService = (0,_async_to_generator/* default */.Z)(function(leadData, currentLead) {
        var infos, resultSaveLead, error, ref, ref1, errorMessage;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    if (!(currentLead === null || currentLead === void 0 ? void 0 : currentLead.attributes)) {
                        return [
                            2,
                            getApiStatusError("lead_not_found", {
                                leadData: leadData,
                                currentLead: currentLead
                            })
                        ];
                    }
                    return [
                        4,
                        getInfos()
                    ];
                case 1:
                    infos = _state.sent();
                    return [
                        4,
                        getIntegrationServiceAxios(infos).post(infos.integration_services_api_lead_route, {
                            api_key: infos.integration_services_api_key,
                            data: leadData,
                            external_id: currentLead.attributes.external_id
                        }).then(function(result) {
                            return result.data;
                        })
                    ];
                case 2:
                    resultSaveLead = _state.sent();
                    return [
                        2,
                        getApiStatusSuccess("sended_lead", resultSaveLead)
                    ];
                case 3:
                    error = _state.sent();
                    errorMessage = (error === null || error === void 0 ? void 0 : error.message) || (error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) || "Erro desconhecido";
                    return [
                        2,
                        getApiStatusError(errorMessage, {
                            leadData: leadData,
                            currentLead: currentLead
                        })
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _sendLeadIntegrationService.apply(this, arguments);
}

;// CONCATENATED MODULE: ./src/services/v2/lead-integration/core/save-external-lead.js




function saveExternalLead(dataLead, context) {
    return _saveExternalLead.apply(this, arguments);
}
function _saveExternalLead() {
    _saveExternalLead = (0,_async_to_generator/* default */.Z)(function(dataLead, context) {
        var ls, currentLead, _tmp, result, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ls = new leads/* LeadService */.y(context === null || context === void 0 ? void 0 : context.req, context === null || context === void 0 ? void 0 : context.res);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        9,
                        ,
                        10
                    ]);
                    if (!context.email) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        ls.findByEmail({
                            email: context.email
                        })
                    ];
                case 2:
                    _tmp = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 3:
                    return [
                        4,
                        ls.find()
                    ];
                case 4:
                    _tmp = _state.sent();
                    _state.label = 5;
                case 5:
                    currentLead = _tmp;
                    if (!(currentLead === null || currentLead === void 0 ? void 0 : currentLead.attributes)) {
                        return [
                            2,
                            false
                        ];
                    }
                    return [
                        4,
                        sendLeadIntegrationService(dataLead, currentLead)
                    ];
                case 6:
                    result = _state.sent();
                    if (!(!currentLead.attributes.external_id && result.data.external_id)) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        ls.save({
                            external_id: result.data.external_id
                        })
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        2,
                        result
                    ];
                case 9:
                    error = _state.sent();
                    return [
                        2,
                        false
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    });
    return _saveExternalLead.apply(this, arguments);
}

;// CONCATENATED MODULE: ./src/services/v2/lead-integration/index.js



;// CONCATENATED MODULE: ./src/services/hooks/index.js








function fluxUpdate() {
    return _fluxUpdate.apply(this, arguments);
}
function _fluxUpdate() {
    _fluxUpdate = (0,_async_to_generator/* default */.Z)(function() {
        var data;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            data = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            if (!data) return [
                2
            ];
            return [
                2,
                axios_default().post("/api/hooks/send-request", data)
            ];
        });
    });
    return _fluxUpdate.apply(this, arguments);
}
/**
 * Centralizador de Hooks
 *
 * Cada Hook precisa seguir as diretrizes de parametros:
 * -> hookname: string
 * -> params: object
 */ function DispathHookUpdate() {
    return _DispathHookUpdate.apply(this, arguments);
}
function _DispathHookUpdate() {
    _DispathHookUpdate = (0,_async_to_generator/* default */.Z)(function() {
        var params, ref, ref1, ref2, ref3, results, infos, hasError, result;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = _arguments.length > 0 && _arguments[0] !== void 0 // -> required -> {}
                     ? _arguments[0] : false;
                    if (!params) {
                        (0,set_log/* SetLog */.J)(set_log/* TagLogs.error_dispath_hook_update */.w.error_dispath_hook_update, {
                            data: "any params"
                        }, false);
                        return [
                            2,
                            false
                        ];
                    }
                    // if (!params.userEmail && !params.body.origem_api) {
                    //   SetLog(TagLogs.error_dispath_hook_update, { data: 'userEmail not informed' }, false)
                    //   return false;
                    // }
                    if (!params.body) {
                        (0,set_log/* SetLog */.J)(set_log/* TagLogs.error_dispath_hook_update */.w.error_dispath_hook_update, {
                            data: "body not informed"
                        }, false);
                        return [
                            2,
                            false
                        ];
                    }
                    // NOVA INTEGRAÇÃO - INICIO
                    (0,set_log/* SetLog */.J)(set_log/* TagLogs.dispath_hook_update */.w.dispath_hook_update, {
                        email: params.userEmail,
                        data: params.body
                    });
                    return [
                        4,
                        saveExternalLead((ref3 = params === null || params === void 0 ? void 0 : params.body) !== null && ref3 !== void 0 ? ref3 : params, {
                            req: params.req,
                            res: params.res,
                            email: params.userEmail
                        })
                    ];
                case 1:
                    _state.sent();
                    results = [];
                    return [
                        4,
                        (0,GetInformationService/* GetInfos */.B)()
                    ];
                case 2:
                    infos = (ref = _state.sent()) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.attributes;
                    hasError = false;
                    return [
                        4,
                        Promise.all(enabledHooks.map(function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function(hook) {
                                var error, _status, _data;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!isEnabledHook(hook.name, infos)) return [
                                                3,
                                                5
                                            ];
                                            _state.label = 1;
                                        case 1:
                                            _state.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4,
                                                hook.fn(params)
                                            ];
                                        case 2:
                                            result = _state.sent();
                                            return [
                                                3,
                                                4
                                            ];
                                        case 3:
                                            error = _state.sent();
                                            result = false;
                                            results.push({
                                                hook: hook.name,
                                                status: error.message,
                                                data: error.message
                                            });
                                            hasError = true;
                                            return [
                                                3,
                                                4
                                            ];
                                        case 4:
                                            results.push({
                                                hook: hook.name,
                                                status: (_status = result.status) !== null && _status !== void 0 ? _status : result,
                                                data: (_data = result.data) !== null && _data !== void 0 ? _data : result
                                            });
                                            if (!result) {
                                                hasError = true;
                                            }
                                            _state.label = 5;
                                        case 5:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(hook) {
                                return _ref.apply(this, arguments);
                            };
                        }()))
                    ];
                case 3:
                    _state.sent();
                    if (hasError) {
                        (0,set_log/* SetLog */.J)(set_log/* TagLogs.error_dispath_hook_update */.w.error_dispath_hook_update, {
                            data: "Uma ou mais integra\xe7\xf5es de hook update falhou",
                            details: results
                        }, false);
                    }
                    return [
                        2,
                        results
                    ];
            }
        });
    });
    return _DispathHookUpdate.apply(this, arguments);
}
/**
 * Verifica se o hook está habilitado na tabela de infos
 *
 * @param {*} key hook a ser verificado - 'sharpspring' | 'pipefy' | ...
 * @param {*} systemInfos {...} lista de attributes em infos table
 * @returns true se habilitado o hook, false caso contrário
 */ function isEnabledHook(key, systemInfos) {
    switch(key){
        case "sharpspring":
            // Enviar para SharpSpring
            return (systemInfos === null || systemInfos === void 0 ? void 0 : systemInfos.usa_sharpspring) == true;
        case "pipefy_lead_data":
            // Enviar para Pipefy em Data Lead
            return (systemInfos === null || systemInfos === void 0 ? void 0 : systemInfos.usa_pipefy) == true;
        // case 'pipefy_lead_step':
        //   // Enviar para Pipefy em Step Lead
        //   return systemInfos?.usa_pipefy == true;
        default:
            // Nada a fazer
            return false;
    }
}
/**
 * Lista de Hooks integrados
 * {
 *  name: 'sharpspring' | 'pipefy' | ...
 *
 *  fn: () => any -> function que executa a integração do update
 *    -> cada function deve verificar se os params recebidos está na gama de itens atualizáveis
 *    -> cada function deve retornar true | false do resultado da operação
 * }
 */ var enabledHooks = [
    {
        name: "sharpspring",
        fn: SendSharp
    },
    {
        name: "pipefy_lead_data",
        fn: SendPipeData
    }, 
];


/***/ }),

/***/ 54967:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ getQueryString; }
/* harmony export */ });
/* unused harmony export FIELDS_LEAD_PIPEFY */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97582);
/* harmony import */ var _logs_set_log__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38479);



/**
 * 
 * @param {*} body data query params
 * @param {*} oper str -> 'update'|'create'
 * @returns 
 */ function getQueryString(body) {
    return _getQueryString.apply(this, arguments);
}
function _getQueryString() {
    _getQueryString = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(body) {
        var oper, pipeType, oldLeadFields, result, accepteds, bodyKeys, field, error;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    oper = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "create", pipeType = _arguments.length > 2 ? _arguments[2] : void 0, oldLeadFields = _arguments.length > 3 ? _arguments[3] : void 0;
                    result = "";
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        filterBody(body, pipeType)
                    ];
                case 2:
                    accepteds = _state.sent();
                    bodyKeys = Object.keys(accepteds);
                    bodyKeys.forEach(function(param) {
                        field = getQuery(param, accepteds[param], oldLeadFields);
                        if (field) {
                            if (oper === "update") {
                                result += ',{fieldId: "'.concat(param, '" value: ').concat(field, " }");
                            } else {
                                result += ',{field_id: "'.concat(param, '", field_value: ').concat(field, "}");
                            }
                        }
                    });
                    if (result == "") {
                        return [
                            2,
                            result
                        ];
                    }
                    return [
                        2,
                        result.slice(1)
                    ];
                case 3:
                    error = _state.sent();
                    (0,_logs_set_log__WEBPACK_IMPORTED_MODULE_0__/* .SetLog */ .J)(_logs_set_log__WEBPACK_IMPORTED_MODULE_0__/* .TagLogs.dispath_hook */ .w.dispath_hook, {
                        data: "PIPEFY Falhou",
                        details: {
                            error: error.message
                        }
                    }, false);
                    return [
                        2,
                        ""
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _getQueryString.apply(this, arguments);
}
var FIELDS_LEAD_PIPEFY = {
    celular: "n_mero_de_telefone",
    celular_txt: "telefone",
    campanha: "campanha",
    campanha_txt: "campanha_texto",
    municipio: "cidade",
    estado: "estado",
    valor_medio_mensal_da_conta: "valor_da_conta_de_luz",
    concessionaria_texto: "concessionaria_texto",
    usina_texto: "usina_texto",
    disponibilidade_atendimento: "disponibilidade_atendimento",
    tipo_conta: "tipo_do_cliente",
    tipo: "para_sua_casa_ou_para_seu_neg_cio",
    assessor: "acessores",
    json_form: "json",
    sms_confirmed: "c_digo_validado",
    nome_contrato: "nome",
    email: "email",
    taxvat_contrato_pf: "cpf",
    taxvat_contrato_pj: "cnpj",
    estado_civil: "sele_o_de_lista",
    profissao: "profiss_o",
    cep_contrato: "cep",
    endereco_contrato: "rua",
    numero_endereco_contrato: "n_mero",
    complemento_endereco_contrato: "complemento",
    completou_fluxo: "completou_o_fluxo_webapp",
    logou_na_plataforma: "clicou_cta_entrar",
    clicou_esqueceu_senha: "clicou_cta_esqueceu_senha",
    nova_senha_inserida: "nova_senha_inserida_clicoucta_atualizar",
    nome_form: "nome_1",
    email_form: "email_1"
};
function filterBody(body, type) {
    return _filterBody.apply(this, arguments);
}
function _filterBody() {
    _filterBody = /**
 * Filtra os campos recebidos para serem compatíveis com os campos integrados na ferramenta
 * @param {*} body {} -> array de keyValues a ser enviado
 * @param {*} type str -> "data"|"step" -> atualizar dados do lead ou comportamentos do lead
 */ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(body, type) {
        var pipeKeys, acceptKeys, bodyKeys, acceptedKeys, lead;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            pipeKeys = FIELDS_LEAD_PIPEFY;
            acceptKeys = Object.keys(pipeKeys);
            bodyKeys = Object.keys(body);
            acceptedKeys = bodyKeys.filter(function(item) {
                return acceptKeys.includes(item);
            });
            lead = {};
            acceptedKeys.map(function(item) {
                lead[pipeKeys[item]] = body[item];
            });
            return [
                2,
                lead
            ];
        });
    });
    return _filterBody.apply(this, arguments);
}
function getQuery(field, value, oldLeadFields) {
    var fields = FIELDS_LEAD_PIPEFY;
    if (!value) {
        // Campo não foi preenchido
        return false;
    }
    switch(field){
        // Campos de seleção múltipla: database ou checklist
        case fields.clique_cta_usina_listing_pipe:
        case fields.clique_cta_usina_listing_nome:
        case fields.clique_cta1_card_usina_listing_nome:
        case fields.clique_cta2_card_usina_listing_nome:
            return getQueryRelationAddedListing(field, value, oldLeadFields);
        // Campo que determina o tipo de conta - PF ou PJ
        case fields.tipo_conta:
            return value == "pf" ? '"Para sua casa"' : '"Para seu neg\xf3cio"';
        default:
            return '"'.concat(value, '"');
    }
}
function getQueryRelationAddedListing(field, value, oldLeadFields) {
    // Recuperando dados atuais do campo
    try {
        var ref, ref1, ref2, ref3, ref4;
        var ref5;
        var oldValue = (ref5 = (ref = oldLeadFields.filter(function(dataField) {
            var ref;
            return (dataField === null || dataField === void 0 ? void 0 : (ref = dataField.field) === null || ref === void 0 ? void 0 : ref.id) == field;
        })) === null || ref === void 0 ? void 0 : ref[0]) !== null && ref5 !== void 0 ? ref5 : [];
        if (!oldValue.array_value) {
            // Campo vazio - default
            oldValue.array_value = [];
        }
        if (((ref1 = oldValue.array_value) === null || ref1 === void 0 ? void 0 : ref1.length) == 0) {
            // Outra possibilidade de campo vazio - usuário pipefy removeu manualmente ou fez alguma alteração
            oldValue.array_value = [
                value === null || value === void 0 ? void 0 : value.trim()
            ];
        } else if (!((ref2 = oldValue.array_value) === null || ref2 === void 0 ? void 0 : ref2.includes(value === null || value === void 0 ? void 0 : value.trim()))) {
            oldValue.array_value.push(value === null || value === void 0 ? void 0 : value.trim());
        }
        var ref6, ref7;
        // Verificando se value é number: caso seja, consideramos que o array seja de numbers
        // montando string com valores atuais
        var newValue = isArrayOfNumbers(oldValue.array_value) ? "[".concat((ref6 = (ref3 = oldValue.array_value) === null || ref3 === void 0 ? void 0 : ref3.join(",")) !== null && ref6 !== void 0 ? ref6 : "", "]") : '["'.concat((ref7 = (ref4 = oldValue.array_value) === null || ref4 === void 0 ? void 0 : ref4.join('","')) !== null && ref7 !== void 0 ? ref7 : "", '"]');
        return newValue;
    } catch (err) {
        console.log({
            err: err.message
        });
    }
}
/**
 * TRUE | FALSE - if is array of numbers
 * @param {*} arr 
 */ var isArrayOfNumbers = function(arr) {
    var flagIsNumber = true;
    arr.map(function(item) {
        if (isNaN(parseInt(item))) {
            flagIsNumber = false;
        }
    });
    return flagIsNumber;
};


/***/ }),

/***/ 38479:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ SetLog; },
/* harmony export */   "w": function() { return /* binding */ TagLogs; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47041);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(cookies_next__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _endpoints_core_secretApiAxios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8783);
/* provided dependency */ var process = __webpack_require__(34155);




/**
 * # Salvamento de Monitoramento das ações dentro do projeto
 * 
 * @param {*} oper Este parâmetro deve ser inserido através de associação de Array, em TagLogs
 *  - Visitar o arquivo que exporta TagLogs para mais detalhes 
 *  - Importar TagLogs e acessar as tags para obter o texto adequado
 *  - Ex: `SetLog(TagLogs.[[log_name]])`
 * 
 * @param {*} dataLog JSON com retalhes da operação, caso queira salvar informações adicionais
 * @param {*} dataResult Resultado da operação, sendo true como captura apenas de monitoramento, ou false quando houver falha
 * @returns null
 */ var SetLog = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(oper, dataLog, dataResult // Bool
    ) {
        var email;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    email = (0,cookies_next__WEBPACK_IMPORTED_MODULE_0__.getCookie)("electy-server@user-email");
                    if (true) return [
                        3,
                        2
                    ];
                    console.log("Server", email);
                    return [
                        4,
                        _endpoints_core_secretApiAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post("".concat(process.env.SECRET_APP_API_URL, "system-logs"), {
                            data: {
                                operacao: oper,
                                data_log: JSON.stringify(dataLog),
                                result: dataResult == true ? true : dataResult == false ? false : null
                            }
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    console.log("Client", email);
                    return [
                        4,
                        _endpoints_core_secretApiAxios__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post("".concat(process.env.PUBLIC_APP_API_URL, "system-logs"), {
                            data: {
                                operacao: oper,
                                data_log: JSON.stringify(dataLog),
                                result: dataResult == true ? true : dataResult == false ? false : null
                            }
                        })
                    ];
                case 3:
                    return [
                        2,
                        _state.sent()
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function SetLog(oper, dataLog, dataResult) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * # COMBINADO COM SetLog(...)
 * 
 * ## Jeito correto de usar SetLog:
 * - `SetLog(TagLogs.[[nome_da_tag]], ...)`
 * - `SetLog(TagLogs.dispath_hook_update, ...)`
 * 
 * ## Jeito errado de usar SetLog:
 * - SetLog('MONITORAMENTO DE EVENTO XXX', ...)
 * 
 * O primeiro parametro da chamada SetLog precisa ser tratado no array TagLogs.
 * Significa que cada texto precisa seguir um padrão de tag conforme expecificado
 * 
 * Havendo necessidade de uma tag específica, é importante que seja incluído nesse array
 * posteriormente utilizado na função a partir do array.
 * 
 * 
 */ var TagLogs = {
    // MONITORING TAGS
    dispath_hook_update: "[MONITORAMENTO] DispathHookUpdate",
    // ERROR TAGS
    error_generic: "[ERROR]",
    error_dispath_hook_update: "[ERROR] DispathHookUpdate",
    error_details_dispath_hook_update: "[ERROR - DETAILS] DispathHookUpdate",
    error_query_dispath_hook_update: "[ERROR - QUERY] DispathHookUpdate",
    error_create_lead: "[ERROR] CREATE LEAD",
    error_update_lead: "[ERROR] UPDATE LEAD",
    error_save_lead: "[ERROR] SAVE LEAD",
    error_find_lead: "[ERROR] FIND LEAD",
    error_create_card_pipefy_fallback: "Create Card Pipefy - Fallback",
    error_sharpspring: "[ERROR] SHARPSPRING",
    error_cep_fallback: "[ERROR] Busca CEP - Fallback",
    error_calculadora_invalid_params: "[ERRO] CALCULADORA - Valida\xe7\xe3o de Campos",
    error_calculadora: "[ERRO] CALCULADORA - Captura de Erro Gen\xe9rica",
    error_sendcontract_email: "[ERROR] ENVIO DE E-MAIL - SendContract",
    error_sendregisterlink_email: "[ERROR] ENVIO DE E-MAIL - SendLinkRegister"
};


/***/ }),

/***/ 53885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ _DispathSaveHookLead; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97582);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47041);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(cookies_next__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31989);
/* harmony import */ var _hooks_pipefy_src_get_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54967);
/* harmony import */ var _logs_set_log__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38479);
/* harmony import */ var _wl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67057);
/* harmony import */ var _SaveLead__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84194);
/* harmony import */ var _FindLead__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84456);
/* harmony import */ var _functions_cookies_COOKIES_TAGS__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(89368);











var _DispathSaveHookLead = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(dataLead1, context) {
        var dataLeadConfigured, resultDispatchHooks, leadId, ref, ref1, ref2, ref3, pipeResult;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    dataLeadConfigured = getConfiguredDataLeadToHook(dataLead1);
                    return [
                        4,
                        (0,_hooks__WEBPACK_IMPORTED_MODULE_1__/* .DispathHookUpdate */ .Q)({
                            body: dataLeadConfigured,
                            pipeId: dataLead1.pipe_id,
                            req: context === null || context === void 0 ? void 0 : context.req,
                            res: context === null || context === void 0 ? void 0 : context.res
                        }).catch(function(err) {
                            (0,_logs_set_log__WEBPACK_IMPORTED_MODULE_3__/* .SetLog */ .J)(_logs_set_log__WEBPACK_IMPORTED_MODULE_3__/* .TagLogs.error_dispath_hook_update */ .w.error_dispath_hook_update, {
                                msg: err.message
                            }, false);
                            return false;
                        })
                    ];
                case 1:
                    resultDispatchHooks = _state.sent();
                    try {
                        leadId = (0,cookies_next__WEBPACK_IMPORTED_MODULE_0__.getCookie)(_functions_cookies_COOKIES_TAGS__WEBPACK_IMPORTED_MODULE_7__/* .COOKIES_TAGS.LEAD_ID */ .t.LEAD_ID, {
                            req: context.req,
                            res: context.res
                        });
                    } catch (error) {}
                    if (!leadId) {
                        leadId = dataLead1 === null || dataLead1 === void 0 ? void 0 : dataLead1.id;
                    }
                    if (!leadId) return [
                        3,
                        3
                    ];
                    pipeResult = (ref = resultDispatchHooks === null || resultDispatchHooks === void 0 ? void 0 : resultDispatchHooks.filter(function(item) {
                        return item.hook == "pipefy_lead_data";
                    })) === null || ref === void 0 ? void 0 : ref[0];
                    // Fallback - Caso haja erro
                    if (!(pipeResult === null || pipeResult === void 0 ? void 0 : pipeResult.status)) {
                        sendFallback(leadId, context);
                    }
                    if (!(pipeResult && (pipeResult === null || pipeResult === void 0 ? void 0 : (ref1 = pipeResult.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.createCard) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.card) === null || ref3 === void 0 ? void 0 : ref3.id))) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        (0,_SaveLead__WEBPACK_IMPORTED_MODULE_5__/* ._SaveLead */ .b)({
                            id: leadId,
                            pipe_id: pipeResult.data.createCard.card.id
                        }, context)
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        2,
                        resultDispatchHooks
                    ];
            }
        });
    });
    return function _DispathSaveHookLead(dataLead1, context) {
        return _ref.apply(this, arguments);
    };
}();
function getConfiguredDataLeadToHook(dataLead1) {
    if (dataLead1.tipo === "pf") {
        dataLead1.tipo = "Para sua casa";
    } else if (dataLead1.tipo === "pj") {
        dataLead1.tipo = "Para seu neg\xf3cio";
    }
    if (dataLead1.json_form) {
        var json = JSON.stringify(dataLead1.json_form);
        dataLead1.json_form = "".concat(json.replaceAll('"', ""));
    }
    var id = dataLead1.id, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(dataLead1, [
        "id"
    ]);
    return rest;
}
function sendFallback(leadId, context) {
    return _sendFallback.apply(this, arguments);
}
function _sendFallback() {
    _sendFallback = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(leadId, context) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, lead, dataLeadConfigured, resultDispatchHooks;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    3;
                    return [
                        4,
                        (0,_FindLead__WEBPACK_IMPORTED_MODULE_6__/* ._FindLead */ .R)(context)
                    ];
                case 1:
                    lead = _state.sent();
                    if (!lead) {
                        return [
                            2,
                            false
                        ];
                    }
                    (0,_logs_set_log__WEBPACK_IMPORTED_MODULE_3__/* .SetLog */ .J)(_logs_set_log__WEBPACK_IMPORTED_MODULE_3__/* .TagLogs.error_create_card_pipefy_fallback */ .w.error_create_card_pipefy_fallback, {
                        msg: "Tratando o lead id: " + leadId
                    }, false);
                    dataLeadConfigured = {
                        celular: phoneNumber,
                        campanha_txt: (ref = resultSaveLead.data) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : ref1.campanha,
                        assessor: (ref2 = resultSaveLead.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.attributes) === null || ref3 === void 0 ? void 0 : ref3.assessor,
                        municipio: "".concat((ref4 = resultSaveLead.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.attributes) === null || ref5 === void 0 ? void 0 : ref5.municipio, " - ").concat((ref6 = resultSaveLead.data) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.attributes) === null || ref7 === void 0 ? void 0 : ref7.uf),
                        valor_medio_mensal_da_conta: (ref8 = resultSaveLead.data) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.attributes) === null || ref9 === void 0 ? void 0 : ref9.valor_consumo,
                        concessionaria_texto: (ref10 = resultSaveLead.data) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.attributes) === null || ref11 === void 0 ? void 0 : ref11.nome_concessionaria,
                        usina_texto: (ref12 = resultSaveLead.data) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.attributes) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.usina) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.data) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.attributes) === null || ref16 === void 0 ? void 0 : ref16.nome_sharpspring,
                        disponibilidade_atendimento: "Sim",
                        tipo: (ref17 = resultSaveLead.data) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.attributes) === null || ref18 === void 0 ? void 0 : ref18.tipo,
                        pipe_id: (ref19 = resultSaveLead.data) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.attributes) === null || ref20 === void 0 ? void 0 : ref20.pipe_id
                    };
                    return [
                        4,
                        (0,_hooks__WEBPACK_IMPORTED_MODULE_1__/* .DispathHookUpdate */ .Q)({
                            body: dataLeadConfigured,
                            pipeId: dataLead.pipe_id,
                            req: context === null || context === void 0 ? void 0 : context.req,
                            res: context === null || context === void 0 ? void 0 : context.res
                        }).catch(function(err) {
                            (0,_logs_set_log__WEBPACK_IMPORTED_MODULE_3__/* .SetLog */ .J)(_logs_set_log__WEBPACK_IMPORTED_MODULE_3__/* .TagLogs.error_dispath_hook_update */ .w.error_dispath_hook_update, {
                                msg: err.message
                            }, false);
                            return false;
                        })
                    ];
                case 2:
                    resultDispatchHooks = _state.sent();
                    return [
                        2,
                        resultDispatchHooks
                    ];
            }
        });
    });
    return _sendFallback.apply(this, arguments);
}


/***/ }),

/***/ 84456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ _FindLead; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97582);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47041);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(cookies_next__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _functions_cookies_COOKIES_TAGS__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89368);
/* harmony import */ var _endpoints_core_secretApiAxios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8783);
/* harmony import */ var _logs_set_log__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38479);






var _FindLead = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
        var id, email, context, currentLead, _tmp, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    id = param.id, email = param.email, context = param.context;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        7,
                        ,
                        8
                    ]);
                    try {
                        id = id ? id : (0,cookies_next__WEBPACK_IMPORTED_MODULE_0__.getCookie)(_functions_cookies_COOKIES_TAGS__WEBPACK_IMPORTED_MODULE_1__/* .COOKIES_TAGS.LEAD_ID */ .t.LEAD_ID, context);
                    } catch (error1) {}
                    if (!email) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        _endpoints_core_secretApiAxios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("leads?filters[email][$eq]=".concat(email, "&sort[id]=desc&populate=conta,usina,contrato_plano_usina")).then(function(data) {
                            var ref;
                            return (ref = data.data) === null || ref === void 0 ? void 0 : ref.data[0];
                        }).catch(function(err) {
                            (0,_logs_set_log__WEBPACK_IMPORTED_MODULE_3__/* .SetLog */ .J)(_logs_set_log__WEBPACK_IMPORTED_MODULE_3__/* .TagLogs.error_find_lead */ .w.error_find_lead, {
                                function: "Erro ao buscar o lead",
                                errorMessage: err.message
                            }, false);
                            return false;
                        })
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    if (!id) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        _endpoints_core_secretApiAxios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("leads/".concat(parseInt(id), "?populate=conta,usina,contrato_plano_usina")).then(function(data) {
                            var ref;
                            return (ref = data.data) === null || ref === void 0 ? void 0 : ref.data;
                        }).catch(function(err) {
                            (0,_logs_set_log__WEBPACK_IMPORTED_MODULE_3__/* .SetLog */ .J)(_logs_set_log__WEBPACK_IMPORTED_MODULE_3__/* .TagLogs.error_find_lead */ .w.error_find_lead, {
                                function: "Erro ao buscar o lead",
                                errorMessage: err.message
                            }, false);
                            return false;
                        })
                    ];
                case 4:
                    _tmp = _state.sent();
                    return [
                        3,
                        6
                    ];
                case 5:
                    _tmp = false;
                    _state.label = 6;
                case 6:
                    currentLead = _tmp;
                    return [
                        2,
                        getFilteredLeadData(currentLead)
                    ];
                case 7:
                    error = _state.sent();
                    return [
                        2,
                        false
                    ];
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
    return function _FindLead(_) {
        return _ref.apply(this, arguments);
    };
}();
function getFilteredLeadData(data) {
    return data;
}


/***/ }),

/***/ 84194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* binding */ _SaveLead; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/cookies-next/lib/index.js
var lib = __webpack_require__(47041);
// EXTERNAL MODULE: ./src/services/endpoints/core/secretApiAxios.js
var secretApiAxios = __webpack_require__(8783);
;// CONCATENATED MODULE: ./src/services/v2/leads/_FilterResponseDataLead.js
var _FilterResponseDataLead = function(data) {
    var lead = data === null || data === void 0 ? void 0 : data.data;
    if (!(lead === null || lead === void 0 ? void 0 : lead.id) || !(lead === null || lead === void 0 ? void 0 : lead.attributes)) {
        return {
            status: false
        };
    }
    return {
        status: true,
        data: {
            id: lead.id,
            attributes: {
                nome: lead.attributes.nome,
                sobrenome: lead.attributes.sobrenome,
                valor_consumo: lead.attributes.valor_consumo,
                email: lead.attributes.email,
                celular: lead.attributes.celular,
                tipo: lead.attributes.tipo,
                municipio: lead.attributes.municipio,
                uf: lead.attributes.uf,
                nome_concessionaria: lead.attributes.nome_concessionaria,
                usina: lead.attributes.usina,
                assessor: lead.attributes.assessor,
                campanha: lead.attributes.campanha,
                expires_time: lead.attributes.expires_time,
                origem_api: lead.attributes.origem_api,
                desconto_anual_previsto: lead.attributes.desconto_anual_previsto,
                desconto_usina: lead.attributes.desconto_usina,
                prazo_cancelamento_contrato_meses: lead.attributes.prazo_cancelamento_contrato_meses,
                prazo_contrato_meses: lead.attributes.prazo_contrato_meses,
                descricao_prazo_contrato: lead.attributes.descricao_prazo_contrato,
                text_prazo_implantacao: lead.attributes.text_prazo_implantacao,
                pipe_id: lead.attributes.pipe_id,
                sms_code: lead.attributes.sms_code,
                sms_confirmed: lead.attributes.sms_confirmed,
                attempts: lead.attributes.attempts,
                createdAt: lead.attributes.createdAt,
                updatedAt: lead.attributes.updatedAt
            }
        }
    };
};

// EXTERNAL MODULE: ./src/functions/cookies/COOKIES_TAGS.js
var COOKIES_TAGS = __webpack_require__(89368);
// EXTERNAL MODULE: ./src/services/logs/set-log.js
var set_log = __webpack_require__(38479);
// EXTERNAL MODULE: ./src/services/v2/leads/_FindLead.js
var _FindLead = __webpack_require__(84456);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
;// CONCATENATED MODULE: ./src/services/v2/concessionaria/index.js





var ConcessionariaService = /*#__PURE__*/ function() {
    "use strict";
    function ConcessionariaService() {
        (0,_class_call_check/* default */.Z)(this, ConcessionariaService);
    }
    (0,_create_class/* default */.Z)(ConcessionariaService, null, [
        {
            key: "findBySigagente",
            value: function findBySigagente(sigagente) {
                return (0,_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    secretApiAxios/* default.get */.Z.get("concessionarias?filters[sigagente][$eq]=".concat(sigagente, "&populate=*")).then(function(data) {
                                        var ref, ref1;
                                        return (ref = data.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1[0];
                                    }).catch(function(err) {
                                        return false;
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "findById",
            value: function findById(id) {
                return (0,_async_to_generator/* default */.Z)(function() {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    secretApiAxios/* default.get */.Z.get("concessionarias?filters[id][$eq]=".concat(parseInt(id))).then(function(data) {
                                        var ref, ref1;
                                        return (ref = data.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1[0];
                                    }).catch(function(err) {
                                        return false;
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "findByMunicipio",
            value: function findByMunicipio(municipio, uf) {
                return (0,_async_to_generator/* default */.Z)(function() {
                    var municipioId;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!municipio || !uf) {
                                    return [
                                        2,
                                        false
                                    ];
                                }
                                return [
                                    4,
                                    secretApiAxios/* default.get */.Z.get("municipios?_q=".concat(encodeURIComponent(municipio), "&filters[uf][$eq]=").concat(encodeURIComponent(uf))).then(function(data) {
                                        var ref, ref1, ref2;
                                        return (ref = data.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.id;
                                    }).catch(function(err) {
                                        console.log({
                                            error: err.response.data
                                        });
                                        return false;
                                    })
                                ];
                            case 1:
                                municipioId = _state.sent();
                                return [
                                    4,
                                    secretApiAxios/* default.get */.Z.get("concessionarias?filters[municipios][id][$eq]=".concat(municipioId)).then(function(data) {
                                        var ref, ref1;
                                        return (ref = data.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1[0];
                                    }).catch(function(err) {
                                        console.log({
                                            error: err.response.data
                                        });
                                        return false;
                                    })
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return ConcessionariaService;
}();

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
;// CONCATENATED MODULE: ./src/functions/filterObject.js
/**
 *
 * @param {Object} obj
 * @param {string[]} keySearchArr
 * @returns Object filtered
 */ 
function filterObjectByKeys(obj, keySearchArr) {
    var filteredObj = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys(obj)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (keySearchArr.includes(key)) {
                filteredObj[key] = obj[key];
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return filteredObj;
}
function removeUndefinedFieldsFromObj(obj) {
    return Object.fromEntries(Object.entries(obj).filter(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
        return value !== undefined;
    }));
}

;// CONCATENATED MODULE: ./src/services/v2/leads/_SaveLead.js












var _SaveLead = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(data, context) {
        var ref, ref1, _obj, parsedData, _tmp, _tmp1, currentLead, resultSavedLead, _tmp2, ref2;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = {
                        id: data.id ? data.id : (0,lib.getCookie)(COOKIES_TAGS/* COOKIES_TAGS.LEAD_ID */.t.LEAD_ID, context),
                        nome: data.nome,
                        sobrenome: data.sobrenome,
                        valor_consumo: data.valor_consumo,
                        email: data.email,
                        celular: data.celular,
                        tipo: data.tipo,
                        municipio: data.municipio,
                        uf: data.uf
                    };
                    if (!parseInt(data.concessionaria)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        ConcessionariaService.findById(data.concessionaria)
                    ];
                case 1:
                    _tmp1 = _state.sent().attributes.sigagente;
                    return [
                        3,
                        3
                    ];
                case 2:
                    _tmp1 = undefined;
                    _state.label = 3;
                case 3:
                    parsedData = (_obj = (_tmp.nome_concessionaria = _tmp1, _tmp.usina = data.usina, _tmp.assessor = data.assessor, _tmp.campanha = data.campanha, _tmp.origem_api = data.origem_api, _tmp), (0,_define_property/* default */.Z)(_obj, "valor_consumo", data.valor_consumo), (0,_define_property/* default */.Z)(_obj, "desconto_anual_previsto", data.desconto_anual_previsto), (0,_define_property/* default */.Z)(_obj, "desconto_usina", data.desconto_usina), (0,_define_property/* default */.Z)(_obj, "prazo_cancelamento_contrato_meses", data.prazo_cancelamento_contrato_meses), (0,_define_property/* default */.Z)(_obj, "prazo_contrato_meses", data.prazo_contrato_meses), (0,_define_property/* default */.Z)(_obj, "descricao_prazo_contrato", data.descricao_prazo_contrato), (0,_define_property/* default */.Z)(_obj, "text_prazo_implantacao", data.text_prazo_implantacao), (0,_define_property/* default */.Z)(_obj, "pipe_id", data.pipe_id), (0,_define_property/* default */.Z)(_obj, "sms_code", data.sms_code), // expires_time: data.expires_time ? new Date(data.expires_time) : undefined,
                    (0,_define_property/* default */.Z)(_obj, "attempts", data.attempts), (0,_define_property/* default */.Z)(_obj, "sms_confirmed", data.sms_confirmed), (0,_define_property/* default */.Z)(_obj, "usina", data.usina), (0,_define_property/* default */.Z)(_obj, "contrato_plano_usina", data.contrato_plano_usina), (0,_define_property/* default */.Z)(_obj, "az_documento", data.az_documento), (0,_define_property/* default */.Z)(_obj, "az_arquivo_conta", data.az_arquivo_conta), (0,_define_property/* default */.Z)(_obj, "az_contrato_social", data.az_contrato_social), (0,_define_property/* default */.Z)(_obj, "cep_contrato", data.cep_contrato), (0,_define_property/* default */.Z)(_obj, "taxvat_contrato", data.taxvat_contrato), (0,_define_property/* default */.Z)(_obj, "numero_endereco_contrato", data.numero_endereco_contrato), (0,_define_property/* default */.Z)(_obj, "endereco_contrato", data.endereco_contrato), (0,_define_property/* default */.Z)(_obj, "nome_contrato", data.nome_contrato), (0,_define_property/* default */.Z)(_obj, "estado_civil", data.estado_civil), (0,_define_property/* default */.Z)(_obj, "profissao", data.profissao), (0,_define_property/* default */.Z)(_obj, "serasa_data", data.serasa_data), (0,_define_property/* default */.Z)(_obj, "serasa_status", data.serasa_status), (0,_define_property/* default */.Z)(_obj, "iniciado_envio_link_registro", data.iniciado_envio_link_registro), (0,_define_property/* default */.Z)(_obj, "status_finalizacao_envio_link_registro", data.status_finalizacao_envio_link_registro), (0,_define_property/* default */.Z)(_obj, "iniciado_envio_contrato", data.iniciado_envio_contrato), (0,_define_property/* default */.Z)(_obj, "status_finalizacao_envio_contrato", data.status_finalizacao_envio_contrato), (0,_define_property/* default */.Z)(_obj, "external_id", data.external_id), (0,_define_property/* default */.Z)(_obj, "link_documentos", data.link_documentos), _obj);
                    parsedData = removeUndefinedFieldsFromObj(parsedData);
                    return [
                        4,
                        (0,_FindLead/* _FindLead */.R)({
                            id: parsedData.id,
                            context: context
                        })
                    ];
                case 4:
                    currentLead = _state.sent();
                    if (parsedData.id && currentLead && !isUpdatableLead(currentLead)) {
                        return [
                            2,
                            {
                                status: false,
                                error_msg: "not_updatable_lead",
                                currentLead: currentLead
                            }
                        ];
                    }
                    if (!(parsedData.id && currentLead)) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        update(parsedData)
                    ];
                case 5:
                    _tmp2 = _state.sent();
                    return [
                        3,
                        8
                    ];
                case 6:
                    return [
                        4,
                        create(parsedData)
                    ];
                case 7:
                    _tmp2 = _state.sent();
                    _state.label = 8;
                case 8:
                    resultSavedLead = _tmp2;
                    resultSavedLead === null || resultSavedLead === void 0 ? void 0 : (ref = resultSavedLead.data) === null || ref === void 0 ? void 0 : delete ref.pipe_id;
                    if (resultSavedLead === null || resultSavedLead === void 0 ? void 0 : (ref1 = resultSavedLead.data) === null || ref1 === void 0 ? void 0 : ref1.id) {
                        ;
                        (0,lib.setCookie)(COOKIES_TAGS/* COOKIES_TAGS.LEAD_ID */.t.LEAD_ID, resultSavedLead === null || resultSavedLead === void 0 ? void 0 : (ref2 = resultSavedLead.data) === null || ref2 === void 0 ? void 0 : ref2.id, context);
                    }
                    return [
                        2,
                        resultSavedLead
                    ];
            }
        });
    });
    return function _SaveLead(data, context) {
        return _ref.apply(this, arguments);
    };
}();
function update(data) {
    return _update.apply(this, arguments);
}
function _update() {
    _update = (0,_async_to_generator/* default */.Z)(function(data) {
        var resultUpdate;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        secretApiAxios/* default.put */.Z.put("leads/".concat(parseInt(data.id), "?populate=usina,concessionaria"), {
                            data: data
                        }).then(function(data) {
                            return data.data;
                        }).catch(function(err) {
                            (0,set_log/* SetLog */.J)(set_log/* TagLogs.error_update_lead */.w.error_update_lead, data, false);
                            return false;
                        })
                    ];
                case 1:
                    resultUpdate = _state.sent();
                    return [
                        2,
                        _FilterResponseDataLead(resultUpdate)
                    ];
            }
        });
    });
    return _update.apply(this, arguments);
}
function create(data) {
    return _create.apply(this, arguments);
}
function _create() {
    _create = (0,_async_to_generator/* default */.Z)(function(data) {
        var id, parsedData, resultCreate;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    id = data.id, parsedData = (0,_object_without_properties/* default */.Z)(data, [
                        "id"
                    ]);
                    return [
                        4,
                        secretApiAxios/* default.post */.Z.post("leads?populate=usina,concessionaria", {
                            data: parsedData
                        }).then(function(data) {
                            return data.data;
                        }).catch(function(err) {
                            console.log(err.message);
                            (0,set_log/* SetLog */.J)(set_log/* TagLogs.error_create_lead */.w.error_create_lead, data, false);
                            return false;
                        })
                    ];
                case 1:
                    resultCreate = _state.sent();
                    return [
                        2,
                        _FilterResponseDataLead(resultCreate)
                    ];
            }
        });
    });
    return _create.apply(this, arguments);
}
function isUpdatableLead(lead) {
    if (!lead) {
        return false;
    }
    if (lead.attributes.conta) {
        return false;
    }
    return true;
}


/***/ }),

/***/ 39671:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ LeadService; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97582);
/* harmony import */ var _SaveLead__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84194);
/* harmony import */ var _DispathSaveHookLead__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53885);
/* harmony import */ var _FindLead__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84456);







/**
 * Serviço para salvar Leads - Nova Jornada
 */ var LeadService = function LeadService(req, res) {
    "use strict";
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, LeadService);
    var _this = this;
    (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, "save", function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(dataLead) {
            var resultSaveLead;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,_SaveLead__WEBPACK_IMPORTED_MODULE_0__/* ._SaveLead */ .b)(dataLead, _this)
                        ];
                    case 1:
                        resultSaveLead = _state.sent();
                        return [
                            2,
                            resultSaveLead
                        ];
                }
            });
        });
        return function(dataLead) {
            return _ref.apply(this, arguments);
        };
    }());
    var _this1 = this;
    (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, "find", /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
        var id;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    id = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : null;
                    return [
                        4,
                        (0,_FindLead__WEBPACK_IMPORTED_MODULE_2__/* ._FindLead */ .R)({
                            id: id,
                            context: {
                                req: _this1.req,
                                res: _this1.res
                            }
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    }));
    var _this2 = this;
    (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, "findByEmail", function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(email) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,_FindLead__WEBPACK_IMPORTED_MODULE_2__/* ._FindLead */ .R)({
                                email: email,
                                context: {
                                    req: _this2.req,
                                    res: _this2.res
                                }
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(email) {
            return _ref.apply(this, arguments);
        };
    }());
    var _this3 = this;
    (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, "dispathSaveHookLead", function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(dataLead) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                return [
                    2,
                    (0,_DispathSaveHookLead__WEBPACK_IMPORTED_MODULE_1__/* ._DispathSaveHookLead */ .$)(dataLead, {
                        req: _this3.req,
                        res: _this3.res
                    })
                ];
            });
        });
        return function(dataLead) {
            return _ref.apply(this, arguments);
        };
    }());
    this.req = req;
    this.res = res;
};


/***/ }),

/***/ 67057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* binding */ GetWLData; }
});

;// CONCATENATED MODULE: ./src/constants/wl/reenergisa/index.js
var wlDatas = {
    attributes: {
        campanha_default: "LP - (Re) Energisa",
        empresa: "ENERGISA",
        bg_color: null,
        cor_hover_botao_icon: "#B3BD33",
        usar_configuracao_padrao: false,
        steps_contratacao_pf: [
            {
                name: "Dados Pessoais",
                index: "1"
            },
            {
                name: "Endere\xe7o",
                index: "2"
            },
            {
                name: "Identifica\xe7\xe3o",
                index: "3"
            },
            {
                name: "Conta de luz",
                index: "4"
            },
            {
                name: "Confirma\xe7\xe3o",
                index: "5"
            },
            {
                name: "Assinatura de Contrato",
                index: "6"
            }, 
        ],
        steps_contratacao_pj: [
            {
                name: "Dados da empresa",
                index: "1"
            },
            {
                name: "Identifica\xe7\xe3o",
                index: "2"
            },
            {
                name: "Conta de luz",
                index: "3"
            },
            {
                name: "Confirma\xe7\xe3o",
                index: "4"
            },
            {
                name: "Assinatura de Contrato",
                index: "5"
            }, 
        ],
        steps_contratacao_ml: [
            {
                name: "Dados da empresa",
                index: "1"
            },
            {
                name: "Identifica\xe7\xe3o",
                index: "2"
            },
            {
                name: "Assinatura de contrato",
                index: "3"
            }, 
        ],
        steps_dashboard_pf: [
            {
                name: "Usina selecionada",
                index: "1"
            },
            {
                name: "Contrato submetido para an\xe1lise",
                index: "2"
            },
            {
                name: "Contrato assinado com a usina",
                index: "3"
            },
            {
                name: "Seu desconto chegou!",
                index: "4"
            }, 
        ],
        steps_dashboard_pj: [
            {
                name: "Usina selecionada",
                index: "1"
            },
            {
                name: "Contrato submetido para an\xe1lise",
                index: "2"
            },
            {
                name: "Contrato assinado com a usina",
                index: "3"
            },
            {
                name: "Seu desconto chegou!",
                index: "4"
            }, 
        ],
        steps_dashboard_ml: [
            {
                name: "Contato comercial",
                index: "1"
            },
            {
                name: "Sele\xe7\xe3o de comercializadora ",
                index: "2"
            },
            {
                name: "Envio de documentos e assinatura de contrato",
                index: "3"
            },
            {
                name: "Assinatura de contrato com a comercializadora",
                index: "4"
            },
            {
                name: "Desconto ativo",
                index: "5"
            }, 
        ],
        config_campos_pipefy_data: {
            nome: "nome",
            sobrenome: "sobrenome",
            email: "email",
            celular: "n_mero_de_telefone",
            municipio: "cidade",
            estado: "estado",
            estado_combo: "estados_combobox",
            tipo_conta: "para_sua_casa_ou_para_seu_neg_cio_2",
            valor_medio_mensal_da_conta: "valor_m_dio_mensal_na_conta_de_luz",
            representante: "campanha",
            assessor: "acessores",
            clique_ver_ofertas_disponiveis: "clique_cta_ver_ofertas_dispon_veis",
            economia_estimada: "economia_estimada",
            concessionaria_pipe: "concessionaria",
            usina_ofertada_pipe: "geradora_escolhida",
            clique_cta_usina_listing_pipe: "geradora_listing",
            clique_cta1_card_usina_pipe: "clicou_cta_1_geradora",
            clique_cta2_card_usina_pipe: "clicou_cta_2_geradora",
            disponibilidade_atendimento: "disponibilidade_atendimento",
            nome_concessionaria: "concessionaria_new",
            nome_usina_ofertada: "lista_1",
            nome_concessionaria_txt: "concessionaria_txt_1",
            nome_usina_ofertada_txt: "geradora_txt_1",
            clique_cta_usina_listing_nome: "geradora_listing_new",
            clique_cta1_card_usina_listing_nome: "clique_cta1_card_geradora_new",
            clique_cta2_card_usina_listing_nome: "copy_of_clique_cta1_card_geradora_new",
            clique_cta_solicitar_ml: "fale_com_nosso_time",
            mercado_livre: "cliente_mercado_livre",
            nome_contrato: "nome_contrato",
            cnpj: "cnpj",
            cpf: "cpf",
            cep: "cep",
            endereco_rua: "rua",
            complemento: "complemento",
            numero: "n_mero",
            completou_fluxo: "completou_o_fluxo",
            engajamento_com_proposta_de_valor: "engajamento_com_proposta_de_valor",
            logou_na_plataforma: "clicou_cta_entrar",
            clique_cta_continuar1_ml: "clicou_cta_1_de_ml_continuar",
            clique_cta_continuar2_ml: "clicou_cta_2_de_ml_continuar",
            conta_de_luz_enviada: "conta_de_luz_enviada",
            codigo_validado: "c_digo_validado",
            confirmacao_dados: "confirma_o_de_dados",
            origem_api: "origem_api"
        },
        config_campos_sharpspring: {
            cep: "cep_64ecac25b432a",
            cpf: "cpf_cnpj_64ecab788aa2a",
            kwh: "kwh_64ecabc90f2d5",
            city: "city",
            cnpj: "cnpj_64ed0b76d3cf8",
            nome_contrato: "",
            email: "emailAddress",
            state: "state",
            title: "title",
            active: "active",
            estado: "estado_64ecabf0dc66b",
            numero: "n__mero_64ed0c1e4ecb7",
            status: "status",
            street: "street",
            celular: "phoneNumber",
            country: "country",
            ownerID: "ownerID",
            persona: "persona",
            website: "website",
            zipcode: "zipcode",
            industry: "industry",
            pessoa_f: "pessoa_f__sica_jur__dica__64ecabb7057a8",
            accountID: "accountID",
            faxNumber: "faxNumber",
            firstName: "firstName",
            isContact: "isContact",
            leadScore: "leadScore",
            municipio: "munic__pio_64ecab4e528ec",
            campaignID: "campaignID",
            isCustomer: "isCustomer",
            leadStatus: "leadStatus",
            pessoa_jur: "pessoa_jur__dica__64ed0d214e17a",
            trackingID: "trackingID",
            companyName: "companyName",
            complemento: "complemento_64ed0acf59bb4",
            description: "description",
            isQualified: "isQualified",
            emailAddress: "emailAddress",
            endereco_rua: "endere__o_64ecabd4cfd83",
            lista_espera: "",
            mercado_livre: "",
            concessionaria: "concession__ria_64ed0b1a57f70",
            isUnsubscribed: "isUnsubscribed",
            url_identidade: "documento_de_identifica____o_64ecaacb276a0",
            usina_ofertada: "usina_ofertada_64ed0cccb91b8",
            completou_fluxo: "completou_o_fluxo_64ecaa9d5e6db",
            consumo_de_pico: "",
            createTimestamp: "createTimestamp",
            periodo_de_pico: "per__odo_de_pico_64ed0c33e125d",
            tipo_de_moradia: "",
            updateTimestamp: "updateTimestamp",
            url_conta_de_luz: "conta_de_luz_64ecaabd9721f",
            economia_estimada: "economia_estimada_64ed0bb32812a",
            leadScoreWeighted: "leadScoreWeighted",
            mobilePhoneNumber: "mobilePhoneNumber",
            logou_na_plataforma: "logou_na_plataforma__64ecab082dbad",
            municipio_uf_espera: "",
            onboarding_1_submit: "onboarding_1_submit_64ef337a12423",
            onboarding_2_submit: "onboarding_2_submit_64ef33910f1ca",
            onboarding_3_submit: "onboarding_3_submit_64ef33a6a9274",
            onboarding_4_submit: "onboarding_4_submit_64ef33bc9734a",
            onboarding_5_submit: "onboarding_5_submit_64ef33d470745",
            onboarding_6_submit: "onboarding_6_submit_64ef33e9f15a8",
            unidade_consumidora: "",
            url_contrato_social: "contrato_social_64ecaad8492b1",
            conta_de_luz_enviada: "",
            ml_contrato_assinado: "",
            phoneNumberExtension: "phoneNumberExtension",
            clique_cta1_card_usina: "clique_cta_1_card_usina_64ecaa29e4d65",
            clique_cta2_card_usina: "clique_cta_2_card_usina_64ecaa52302da",
            clique_cta_solicitar_ml: "clique_cta_solicitar_contato_ml_64ef358d73544",
            clique_cta_continuar1_ml: "clique_cta_continuar1_ml_64ef361c9bcf5",
            clique_cta_continuar2_ml: "clique_cta_continuar2_ml_64ef35bc6e804",
            clique_cta_usina_listing: "clique_cta_usina_listing_64eca9f82c82d",
            quantos_residentes_na_casa: "",
            clique_cta_ver_propostas_ml: "",
            disponibilidade_atendimento: "disponibilidade_atendimento__64ed0b9640692",
            valor_medio_mensal_da_conta: "valor_m__dio_mensal_da_conta_64eca9611c8df",
            clique_ver_ofertas_disponiveis: "clique_cta_ver_ofertas_dispon__veis_64ecaa85186c6",
            engajamento_com_proposta_de_valor: ""
        },
        bg_color_frame: null,
        cor_tema_primaria: "#009BBE",
        cor_tema_secundaria: "#C3CD3C",
        cor_tema_3: "#CCEBF2",
        cor_tema_4: "#CCEBF2",
        cor_tema_5: "#009BBE",
        cor_tema_botao_solido: "#c3cd3c",
        cor_texto_botao: "#000000",
        cor_tema_botao_desabilitado: "#EDF0C5",
        botao_gradiente: null,
        cor_botao_icone: "#c3cd3c",
        cor_tema_botao_borda: "#009bbe",
        cor_hover_botao_borda: "#ccebf2",
        cor_tema_step_default: "#009BBE",
        cor_ponta_inferior_lateral_esquerda: "#0083B1",
        consentimento_cookie_text: "Armazenamos cookies para melhorar sua experi\xeancia de navega\xe7\xe3o. Conheca nossa [[Pol\xedtica de Privacidade]]",
        code_tag_manager: "54B6FBNB",
        logo_empresa: {
            data: {
                attributes: {
                    url: "/wl/reenergisa/logo_empresa.svg"
                }
            }
        },
        logo_empresa_2: {
            data: {
                attributes: {
                    url: "/wl/reenergisa/logo_empresa_2.svg"
                }
            }
        },
        logo_empresa_rodape: {
            data: {
                attributes: {
                    url: "/wl/reenergisa/logo_empresa_rodape.svg"
                }
            }
        },
        favicon: {
            data: {
                attributes: {
                    url: "/wl/reenergisa/favicon.png"
                }
            }
        },
        bg_img_frame: {
            data: null
        },
        splash: {
            data: {
                attributes: {
                    url: "/wl/reenergisa/splash.gif"
                }
            }
        },
        card_esquerda: {
            data: {
                attributes: {
                    url: "/wl/reenergisa/card_esquerda.svg"
                }
            }
        },
        bg_img_redirect: {
            data: null
        },
        icone_whatsapp: {
            data: {
                attributes: {
                    url: "/wl/reenergisa/icone_whatsapp.png"
                }
            }
        },
        icone_duvidas: {
            data: {
                attributes: {
                    url: "/wl/reenergisa/icone_duvidas.png"
                }
            }
        },
        bg_img_manutencao: {
            data: {
                attributes: {
                    url: "/wl/reenergisa/bg_img_manutencao.png"
                }
            }
        },
        bg_img_error_aplicacao: {
            data: {
                attributes: {
                    url: "/wl/reenergisa/bg_img_error_aplicacao.png"
                }
            }
        },
        Onboarding: {
            header_color: true,
            titulo_bem_vindo: "Bem vindo a (re)energisa!",
            titulo_onboarding_1: "Por que a (re)energisa?",
            descricao_onboarding_1: "Voc\xea vai conhecer um novo jeito de consumir energia: mais barata, mais sustent\xe1vel, com mais liberdade de escolha e facilidade!",
            titulo_onboarding_2: " Energia na palma da sua m\xe3o",
            descricao_onboarding_2: "Escolha a usina parceira e o tipo de energia que ir\xe1 consumir na sua casa.  Economize na conta de luz e tenha uma atitude sustent\xe1vel.  ",
            titulo_onboarding_3: "Muito simples e seguro ",
            descricao_onboarding_3: "A contrata\xe7\xe3o \xe9 simples e segura. E n\xe3o se preocupe com falta de luz, pois voc\xea continuar\xe1 ligado ao fornecimento tradicional de energia.",
            titulo_onboarding_4: "Escolha o melhor para voc\xea ",
            descricao_onboarding_4: "Informe o seu consumo. A gente apresenta as possibilidades. Voc\xea assina o contrato e n\xf3s avisamos \xe0 usina e a sua distribuidora. ",
            titulo_onboarding_5: "Economia o ano inteiro ",
            descricao_onboarding_5: "No final do ciclo de consumo, voc\xea vai passar a pagar duas contas mas, o valor total ser\xe1 at\xe9 25% menor do que aquele que voc\xea paga hoje. ",
            titulo_onboarding_6: "Fa\xe7a sua escolha",
            descricao_onboarding_6: "Chega de pagar caro por energia el\xe9trica! Seja sustent\xe1vel e economize. \nBora come\xe7ar essa mudan\xe7a?",
            background_img: null,
            bg_img_onboarding_1: {
                data: {
                    attributes: {
                        url: "/wl/reenergisa/bg_img_onboarding_1.png"
                    }
                }
            },
            bg_img_onboarding_2: {
                data: {
                    attributes: {
                        url: "/wl/reenergisa/bg_img_onboarding_2.png"
                    }
                }
            },
            bg_img_onboarding_3: {
                data: {
                    attributes: {
                        url: "/wl/reenergisa/bg_img_onboarding_3.png"
                    }
                }
            },
            bg_img_onboarding_4: {
                data: {
                    attributes: {
                        url: "/wl/reenergisa/bg_img_onboarding_4.png"
                    }
                }
            },
            bg_img_onboarding_5: {
                data: {
                    attributes: {
                        url: "/wl/reenergisa/bg_img_onboarding_5.png"
                    }
                }
            },
            bg_img_onboarding_6: {
                data: {
                    attributes: {
                        url: "/wl/reenergisa/bg_img_onboarding_6.png"
                    }
                }
            }
        },
        Usuario: {
            bg_img_confirmacao_conta: {
                data: {
                    attributes: {
                        url: "/wl/reenergisa/bg_img_confirmacao_conta.png"
                    }
                }
            },
            bg_img_email_enviado: {
                data: {
                    attributes: {
                        url: "/wl/reenergisa/bg_img_email_enviado.png"
                    }
                }
            },
            bg_img_erro_link_invalido: {
                data: {
                    attributes: {
                        url: "/wl/reenergisa/bg_img_erro_link_invalido.png"
                    }
                }
            },
            bg_img_password_reset: {
                data: {
                    attributes: {
                        url: "/wl/reenergisa/bg_img_password_reset.png"
                    }
                }
            },
            bg_img_password_reset_success: {
                data: {
                    attributes: {
                        url: "/wl/reenergisa/bg_img_password_reset_success.png"
                    }
                }
            },
            bg_img_reenviar_email: {
                data: {
                    attributes: {
                        url: "/wl/reenergisa/bg_img_reenviar_email.png"
                    }
                }
            },
            bg_img_sem_conta: {
                data: {
                    attributes: {
                        url: "/wl/reenergisa/bg_img_sem_conta.png"
                    }
                }
            }
        },
        Calculadora: {
            cor_botao_select: "#009bbe",
            texto_descricao_consumo: "Quanto sua empresa gasta com luz por m\xeas?",
            cor_hover_botao_icon: "#CCEBF2",
            habilitar_contrato_pf: false,
            habilitar_contrato_pj: true,
            habilitar_captura_fornecedor: true,
            texto_captura_fornecedor: "Seja um gerador parceiro (re)energisa!",
            bg_img_calculadora_success: {
                data: {
                    attributes: {
                        url: "/wl/reenergisa/bg_img_calculadora_success.png"
                    }
                }
            },
            bg_img_calculadora_not_found: {
                data: {
                    attributes: {
                        url: "/wl/reenergisa/bg_img_calculadora_not_found.png"
                    }
                }
            },
            titulo_sem_estoque: "Ah, que pena! A energia esgotou na sua regi\xe3o, devido a alta demanda.",
            descricao_sem_estoque: "Estamos trabalhando para ampliar a oferta de energia limpa e oferec\xea-la novamente em sua regi\xe3o. N\xe3o desanime! Enquanto isso, voc\xea est\xe1 em nossa lista de espera e vamos te mantendo atualizado de todas as novidades da (re)energisa.",
            img_sem_estoque: {
                data: {
                    attributes: {
                        url: "/wl/reenergisa/img_sem_estoque.png"
                    }
                }
            },
            titulo_nao_atendida: "Ah, que pena! Ainda n\xe3o atendemos a sua regi\xe3o.",
            descricao_nao_atendida: "Estamos trabalhando para em breve, oferecer energia limpa e mais em conta para voc\xea e todo Brasil. Enquanto isso, vamos te mantendo atualizado de todas as novidades da (re)energisa.",
            img_nao_atendida: {
                data: {
                    attributes: {
                        url: "/wl/reenergisa/img_nao_atendida.png"
                    }
                }
            },
            img_form_fornecedor: {
                data: {
                    attributes: {
                        url: "/wl/reenergisa/img_form_fornecedor.png"
                    }
                }
            },
            img_sem_consumo_minimo: {
                data: null
            }
        },
        Coleta_Dados_Usuario: {
            bg_img_code_sms: {
                data: {
                    attributes: {
                        url: "/wl/reenergisa/bg_img_code_sms.png"
                    }
                }
            },
            bg_img_confirmacao_dados_confirmacao_sms: {
                data: null
            },
            bg_img_localizacao: {
                data: {
                    attributes: {
                        url: "/wl/reenergisa/bg_img_localizacao.png"
                    }
                }
            },
            bg_img_localizacao_nao_encontrado: {
                data: {
                    attributes: {
                        url: "/wl/reenergisa/bg_img_localizacao_nao_encontrado.png"
                    }
                }
            }
        },
        Formulario: {
            bg_img_form: {
                data: {
                    attributes: {
                        url: "/wl/reenergisa/bg_img_form.png"
                    }
                }
            },
            bg_img_form_confirmacao: {
                data: {
                    attributes: {
                        url: "/wl/reenergisa/bg_img_form_confirmacao.png"
                    }
                }
            },
            bg_img_tooltip_form: {
                data: {
                    attributes: {
                        url: "/wl/reenergisa/bg_img_tooltip_form.png"
                    }
                }
            }
        },
        Pessoa_Fisica: {
            Step_1: {
                bg_img_dados_nao_encontrados: {
                    data: {
                        attributes: {
                            url: "/wl/reenergisa/bg_img_dados_nao_encontrados.png"
                        }
                    }
                },
                bg_img_dados_pessoais: {
                    data: {
                        attributes: {
                            url: "/wl/reenergisa/bg_img_dados_pessoais.png"
                        }
                    }
                }
            },
            Step_2: {
                bg_img_confirme_dados_endereco: {
                    data: {
                        attributes: {
                            url: "/wl/reenergisa/bg_img_confirme_dados_endereco.png"
                        }
                    }
                },
                bg_img_endereco: {
                    data: {
                        attributes: {
                            url: "/wl/reenergisa/bg_img_endereco.png"
                        }
                    }
                }
            },
            Step_3: {
                bg_img_rg: {
                    data: {
                        attributes: {
                            url: "/wl/reenergisa/bg_img_rg.png"
                        }
                    }
                },
                bg_img_tooltip_rg: {
                    data: {
                        attributes: {
                            url: "/wl/reenergisa/bg_img_tooltip_rg.png"
                        }
                    }
                },
                bg_img_documento_adicionado: {
                    data: {
                        attributes: {
                            url: "/wl/reenergisa/bg_img_documento_adicionado.png"
                        }
                    }
                }
            },
            Step_4: {
                bg_img_conta_luz: {
                    data: {
                        attributes: {
                            url: "/wl/reenergisa/bg_img_conta_luz.png"
                        }
                    }
                },
                bg_img_tooltip_conta_luz: {
                    data: {
                        attributes: {
                            url: "/wl/reenergisa/bg_img_tooltip_conta_luz.png"
                        }
                    }
                },
                bg_img_conta_luz_adicionada: {
                    data: {
                        attributes: {
                            url: "/wl/reenergisa/bg_img_conta_luz_adicionada.png"
                        }
                    }
                }
            },
            Step_5: {
                bg_img_confirmacao_conta: {
                    data: {
                        attributes: {
                            url: "/wl/reenergisa/bg_img_confirmacao_conta.png"
                        }
                    }
                }
            }
        },
        Pessoa_Juridica: {
            Step_1_pj: {
                bg_img_contrado_social_pj: {
                    data: {
                        attributes: {
                            url: "/wl/reenergisa/bg_img_contrado_social_pj.png"
                        }
                    }
                },
                bg_img_tooltip_contrado_social_pj: {
                    data: {
                        attributes: {
                            url: "/wl/reenergisa/bg_img_tooltip_contrado_social_pj.png"
                        }
                    }
                },
                bg_img_vamos_comecar_pj: {
                    data: {
                        attributes: {
                            url: "/wl/reenergisa/bg_img_vamos_comecar_pj.png"
                        }
                    }
                },
                bg_img_dados_empresa_pj: {
                    data: {
                        attributes: {
                            url: "/wl/reenergisa/bg_img_dados_empresa_pj.png"
                        }
                    }
                },
                bg_img_contrado_social_adicionado_pj: {
                    data: {
                        attributes: {
                            url: "/wl/reenergisa/bg_img_contrado_social_adicionado_pj.png"
                        }
                    }
                },
                bg_img_confirme_dados_empresa_pj: {
                    data: {
                        attributes: {
                            url: "/wl/reenergisa/bg_img_confirme_dados_empresa_pj.png"
                        }
                    }
                },
                bg_img_possui_demanda_pj: {
                    data: {
                        attributes: {
                            url: "/wl/reenergisa/bg_img_possui_demanda_pj.png"
                        }
                    }
                },
                bg_img_tooltip_possui_demanda_pj: {
                    data: {
                        attributes: {
                            url: "/wl/reenergisa/bg_img_tooltip_possui_demanda_pj.png"
                        }
                    }
                }
            },
            Step_2_pj: {
                bg_img_rg_pj: {
                    data: {
                        attributes: {
                            url: "/wl/reenergisa/bg_img_rg_pj.png"
                        }
                    }
                },
                bg_img_tooltip_rg_pj: {
                    data: {
                        attributes: {
                            url: "/wl/reenergisa/bg_img_tooltip_rg_pj.png"
                        }
                    }
                }
            },
            Step_3_pj: {
                bg_img_conta_luz_pj: {
                    data: {
                        attributes: {
                            url: "/wl/reenergisa/bg_img_conta_luz_pj.png"
                        }
                    }
                },
                bg_img_tooltip_conta_luz_pj: {
                    data: {
                        attributes: {
                            url: "/wl/reenergisa/bg_img_tooltip_conta_luz_pj.png"
                        }
                    }
                },
                bg_img_conta_luz_adicionada_pj: {
                    data: {
                        attributes: {
                            url: "/wl/reenergisa/bg_img_conta_luz_adicionada_pj.png"
                        }
                    }
                }
            },
            Step_4_pj: {
                bg_img_dados_submetidos_pj: {
                    data: {
                        attributes: {
                            url: "/wl/reenergisa/bg_img_dados_submetidos_pj.png"
                        }
                    }
                }
            }
        },
        Email: {
            bg_img_confirmacao_conta: {
                data: {
                    attributes: {
                        url: "/wl/reenergisa/bg_img_email_confirmacao_conta.svg"
                    }
                }
            },
            bg_img_contrato_assinado: {
                data: {
                    attributes: {
                        url: "/wl/ELECTY/img_contrato_assinado.svg"
                    }
                }
            }
        },
        Mercado_Livre: {
            bg_img_sucesso_solicitacao_contato: {
                data: {
                    attributes: {
                        url: "/wl/reenergisa/bg_img_sucesso_solicitacao_contato.png"
                    }
                }
            },
            bg_img_conta_luz_ml: {
                data: {
                    attributes: {
                        url: "/wl/reenergisa/bg_img_conta_luz_ml.png"
                    }
                }
            },
            bg_img_tooltip_conta_luz_ml: {
                data: {
                    attributes: {
                        url: "/wl/reenergisa/bg_img_tooltip_conta_luz_ml.png"
                    }
                }
            },
            bg_img_conta_luz_adicionada_ml: {
                data: {
                    attributes: {
                        url: "/wl/reenergisa/bg_img_conta_luz_adicionada_ml.png"
                    }
                }
            },
            entenda_porque_1: {
                data: {
                    attributes: {
                        url: "/wl/reenergisa/entenda_porque_1.png"
                    }
                }
            },
            bg_img_contrato_social_adicionado_ml: {
                data: {
                    attributes: {
                        url: "/wl/reenergisa/bg_img_contrato_social_adicionado_ml.png"
                    }
                }
            },
            bg_img_documento_adicionado_ml: {
                data: {
                    attributes: {
                        url: "/wl/reenergisa/bg_img_documento_adicionado_ml.png"
                    }
                }
            },
            bg_img_contrato_social_ml: {
                data: {
                    attributes: {
                        url: "/wl/reenergisa/bg_img_contrato_social_ml.png"
                    }
                }
            },
            bg_img_tooltip_contrado_social: {
                data: {
                    attributes: {
                        url: "/wl/reenergisa/bg_img_tooltip_contrado_social.png"
                    }
                }
            },
            bg_img_tooltip_documento_ml: {
                data: {
                    attributes: {
                        url: "/wl/reenergisa/bg_img_tooltip_documento_ml.png"
                    }
                }
            },
            bg_img_documento_ml: {
                data: {
                    attributes: {
                        url: "/wl/reenergisa/bg_img_documento_ml.png"
                    }
                }
            }
        },
        Zapsign: {
            bg_img_assinatura_contrato: {
                data: {
                    attributes: {
                        url: "/wl/reenergisa/bg_img_assinatura_contrato.png"
                    }
                }
            },
            bg_img_contrato_assinado: {
                data: {
                    attributes: {
                        url: "/wl/reenergisa/bg_img_contrato_assinado.png"
                    }
                }
            }
        }
    }
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./src/constants/wl/ELECTY/index.js

var _obj;
var ELECTY_wlDatas = {
    attributes: {
        campanha_default: "ElectyWebApp",
        empresa: "ELECTY",
        bg_color: null,
        cor_hover_botao_icon: "#99E8B4",
        usar_configuracao_padrao: true,
        steps_contratacao_pf: [
            {
                name: "Dados Pessoais",
                index: "1"
            },
            {
                name: "Endere\xe7o",
                index: "2"
            },
            {
                name: "Identifica\xe7\xe3o",
                index: "3"
            },
            {
                name: "Conta de luz",
                index: "4"
            },
            {
                name: "Confirma\xe7\xe3o",
                index: "5"
            },
            {
                name: "Assinatura de Contrato",
                index: "6"
            }, 
        ],
        steps_contratacao_pj: [
            {
                name: "Dados da empresa",
                index: "1"
            },
            {
                name: "Identifica\xe7\xe3o",
                index: "2"
            },
            {
                name: "Conta de luz",
                index: "3"
            },
            {
                name: "Confirma\xe7\xe3o",
                index: "4"
            },
            {
                name: "Assinatura de Contrato",
                index: "5"
            }, 
        ],
        steps_contratacao_ml: [
            {
                name: "Dados da empresa",
                index: "1"
            },
            {
                name: "Identifica\xe7\xe3o",
                index: "2"
            },
            {
                name: "Assinatura de contrato",
                index: "3"
            }, 
        ],
        steps_dashboard_pf: [
            {
                name: "Usina selecionada",
                index: "1"
            },
            {
                name: "Contrato submetido para an\xe1lise",
                index: "2"
            },
            {
                name: "Contrato assinado com a usina",
                index: "3"
            },
            {
                name: "Seu desconto chegou!",
                index: "4"
            }, 
        ],
        steps_dashboard_pj: [
            {
                name: "Usina selecionada",
                index: "1"
            },
            {
                name: "Contrato submetido para an\xe1lise",
                index: "2"
            },
            {
                name: "Contrato assinado com a usina",
                index: "3"
            },
            {
                name: "Seu desconto chegou!",
                index: "4"
            }, 
        ],
        steps_dashboard_ml: [
            {
                name: "Contato comercial",
                index: "1"
            },
            {
                name: "Sele\xe7\xe3o de comercializadora ",
                index: "2"
            },
            {
                name: "Envio de documentos e assinatura de contrato",
                index: "3"
            },
            {
                name: "Assinatura de contrato com a comercializadora",
                index: "4"
            },
            {
                name: "Desconto ativo",
                index: "5"
            }, 
        ],
        config_campos_pipefy_data: (_obj = {
            celular: "n_mero_de_telefone",
            // celular_txt: "telefone",
            campanha: "campanha",
            // campanha: "campanha_texto",
            municipio: "cidade",
            estado: "estado",
            valorConsumo: "valor_da_conta_de_luz",
            concessionaria: "concessionaria_texto",
            disponibilidade_atendimento: "disponibilidade_atendimento",
            tipo_conta: "tipo_do_cliente",
            xx: "para_sua_casa_ou_para_seu_neg_cio",
            assessor: "acessores",
            // xx: "cupom_de_desconto",         // Não esta comtemplado para a nova jornada
            json_form: "json",
            xxxx: "c_digo_validado",
            nome_contrato: "nome",
            email: "email",
            taxvat_contrato: "cpf"
        }, (0,_define_property/* default */.Z)(_obj, "taxvat_contrato", "cnpj"), (0,_define_property/* default */.Z)(_obj, "xxxx", "sele_o_de_lista"), (0,_define_property/* default */.Z)(_obj, "profissao", "profiss_o"), (0,_define_property/* default */.Z)(_obj, "cep_contrato", "cep"), (0,_define_property/* default */.Z)(_obj, "endereco_contrato", "rua"), (0,_define_property/* default */.Z)(_obj, "numero_endereco_contrato", "n_mero"), (0,_define_property/* default */.Z)(_obj, "complemento_endereco_contrato", "complemento"), // xxxx: "completou_o_fluxo_webapp",    // Na tela dados-form-enviados e na tela confirme-dados-form não consta envio desta confirmação
        (0,_define_property/* default */.Z)(_obj, "json_fase_3", "json_1"), (0,_define_property/* default */.Z)(_obj, "logou_na_plataforma", "clicou_cta_entrar"), _obj),
        // config_campos_pipefy_data: {
        //   nome: 'nome',
        //   sobrenome: 'sobrenome',
        //   email: 'email',
        //   celular: 'n_mero_de_telefone',
        //   municipio: 'cidade',
        //   estado: 'estado',
        //   estado_combo: 'estados_combobox',
        //   tipo_conta: 'para_sua_casa_ou_para_seu_neg_cio_2',
        //   valor_medio_mensal_da_conta: 'valor_m_dio_mensal_na_conta_de_luz',
        //   representante: 'campanha',// Campanha que o lead foi capturado
        //   assessor: 'acessores',// Responsável pelo lead na campanha - opcional
        //   clique_ver_ofertas_disponiveis: 'clique_cta_ver_ofertas_dispon_veis',
        //   economia_estimada: 'economia_estimada',
        //   concessionaria_pipe: 'concessionaria',// ID DA CONCESSIONARIA NO PIPEFY
        //   usina_ofertada_pipe: 'geradora_escolhida',// ID DO GERADOR NO PIPEFY
        //   clique_cta_usina_listing_pipe: 'geradora_listing',// ID DO GERADOR NO PIPEFY
        //   clique_cta1_card_usina_pipe: 'clicou_cta_1_geradora',// ID DO GERADOR NO PIPEFY
        //   clique_cta2_card_usina_pipe: 'clicou_cta_2_geradora',// ID DO GERADOR NO PIPEFY
        //   disponibilidade_atendimento: 'disponibilidade_atendimento',// Sim, Não
        //   nome_concessionaria: 'concessionaria_new',// RECEBE O NOME DA CONCESSIONARIA SELECIONADA
        //   nome_usina_ofertada: 'lista_1',// RECEBE O NOME DA USINA SELECIONADA
        //   nome_concessionaria_txt: 'concessionaria_txt_1',// RECEBE O NOME DA CONCESSIONARIA SELECIONADA PARA BKP
        //   nome_usina_ofertada_txt: 'geradora_txt_1',// RECEBE O NOME DA USINA SELECIONADA PARA BKP
        //   clique_cta_usina_listing_nome: 'geradora_listing_new',// RECEBE O LIST COM NOME DA USINA SELECIONADA
        //   clique_cta1_card_usina_listing_nome: 'clique_cta1_card_geradora_new',// RECEBE O LIST COM NOME DA USINA SELECIONADA
        //   clique_cta2_card_usina_listing_nome: 'copy_of_clique_cta1_card_geradora_new',// RECEBE O LIST COM NOME DA USINA SELECIONADA
        //   clique_cta_solicitar_ml: 'fale_com_nosso_time',
        //   mercado_livre: 'cliente_mercado_livre',
        //   nome_contrato: 'nome_contrato',
        //   cnpj: 'cnpj',
        //   cpf: 'cpf',
        //   cep: 'cep',
        //   endereco_rua: 'rua',
        //   complemento: 'complemento',
        //   numero: 'n_mero',
        //   completou_fluxo: 'completou_o_fluxo',
        //   engajamento_com_proposta_de_valor: 'engajamento_com_proposta_de_valor',
        //   logou_na_plataforma: 'clicou_cta_entrar',
        //   clique_cta_continuar1_ml: 'clicou_cta_1_de_ml_continuar',
        //   clique_cta_continuar2_ml: 'clicou_cta_2_de_ml_continuar',
        //   conta_de_luz_enviada: 'conta_de_luz_enviada',
        //   codigo_validado: 'c_digo_validado',
        //   confirmacao_dados: 'confirma_o_de_dados',
        //   origem_api: 'origem_api',
        // },
        config_campos_pipefy_step: {},
        config_campos_sharpspring: {
            cep: "cep_632722cc60e5b",
            cpf: "cpf_63272c763e68f",
            kwh: "kwh_636463b37e3e5",
            city: "city",
            cnpj: "cnpj_638f40958ef62",
            nome_contrato: "nome_do_contratante_637672c65a776",
            email: "emailAddress",
            state: "state",
            title: "title",
            active: "active",
            estado: "estado_br_63272aa7507fd",
            numero: "n__mero_636af156a0648",
            status: "status",
            street: "street",
            celular: "phoneNumber",
            country: "country",
            ownerID: "ownerID",
            persona: "persona",
            website: "website",
            zipcode: "zipcode",
            industry: "industry",
            pessoa_f: "pessoa_f__sica_632721dc6a4e4",
            accountID: "accountID",
            faxNumber: "faxNumber",
            firstName: "firstName",
            isContact: "isContact",
            leadScore: "leadScore",
            municipio: "munic__pio_632723186b971",
            campaignID: "campaignID",
            isCustomer: "isCustomer",
            leadStatus: "leadStatus",
            pessoa_jur: "pessoa_jur__dica__632722135ac4d",
            trackingID: "trackingID",
            companyName: "companyName",
            complemento: "complemento_636af299c28af",
            description: "description",
            isQualified: "isQualified",
            emailAddress: "emailAddress",
            endereco_rua: "endere__o_rua_632722fb24df9",
            lista_espera: "est___na_lista_de_espera__636c140ab9171",
            mercado_livre: "mercado_livre_6480debf37b28",
            concessionaria: "concession__ria_63272b2dc7930",
            isUnsubscribed: "isUnsubscribed",
            url_identidade: "documento_de_identidade__produto__64ca9e60f263c",
            usina_ofertada: "usina_ofertada_63272c5479152",
            completou_fluxo: "contrato_assinado__63272dd25a120",
            consumo_de_pico: "consumo_de_pico_63272b55ee53c",
            createTimestamp: "createTimestamp",
            periodo_de_pico: "per__odo_de_pico_633c271c6bc78",
            tipo_de_moradia: "tipo_de_moradia_633c27bce07ab",
            updateTimestamp: "updateTimestamp",
            url_conta_de_luz: "conta_de_luz__produto__64ca9e74bc7df",
            economia_estimada: "economia_estimada_63272b7386d0b",
            leadScoreWeighted: "leadScoreWeighted",
            mobilePhoneNumber: "mobilePhoneNumber",
            logou_na_plataforma: "clique_ver_ofertas_dispon__veis_647739e4342ab ",
            municipio_uf_espera: "munic__pio_uf_em_espera_636c14369ad87",
            onboarding_1_submit: "input_id",
            onboarding_2_submit: "input_id",
            onboarding_3_submit: "input_id",
            onboarding_4_submit: "input_id",
            onboarding_5_submit: "input_id",
            onboarding_6_submit: "input_id",
            unidade_consumidora: "unidade_consumidora_63647219059c7",
            url_contrato_social: "contrato_social__produto__64ca9e86a95c0",
            conta_de_luz_enviada: "conta_de_luz_enviada__63272d2beab87",
            ml_contrato_assinado: "ml_contrato_assinado_649322802595c",
            phoneNumberExtension: "phoneNumberExtension",
            clique_cta1_card_usina: "clique_cta_usina_listing__1__6477b9422e135",
            clique_cta2_card_usina: "clique_cta_usina_listing__1___1__6477b94bb741b",
            clique_cta_solicitar_ml: "clique_cta_solicitar_ml_6491fd92a31de",
            clique_cta_continuar1_ml: "clique_cta_continuar1_ml_6491fddf70b46",
            clique_cta_continuar2_ml: "clique_cta_continuar2_ml_6491fdff2563f",
            clique_cta_usina_listing: "cta_usina_listing_jacarepagua_64773c4d987ee",
            quantos_residentes_na_casa: "quantos_residentes_na_casa__633c28b16396e",
            clique_cta_ver_propostas_ml: "p__s_login_clique_cta_ver_propostas_64931ee291e99",
            disponibilidade_atendimento: "disponibilidade_atendimento__636ab4a0f0d91",
            valor_medio_mensal_da_conta: "valor_m__dio_mensal_da_conta_633c29221d7cc",
            clique_ver_ofertas_disponiveis: "clique_ver_ofertas_dispon__veis_647739e4342ab",
            engajamento_com_proposta_de_valor: "engajamento_com_proposta_de_valor__63245af1cb5cd"
        },
        bg_color_frame: null,
        cor_tema_primaria: "#26A150",
        cor_tema_secundaria: "#48BE70",
        cor_tema_3: "#ccf6d9",
        cor_tema_4: "#99E8B4",
        cor_tema_5: "#48BE70",
        cor_tema_botao_solido: "#26A150",
        cor_texto_botao: "#FFFFFF",
        cor_tema_botao_desabilitado: "#F2F5F2",
        cor_tema_botao_borda_desabilitado: "#B6B8B7",
        botao_gradiente: null,
        cor_botao_icone: "#26A150",
        cor_tema_botao_borda: "#26A150",
        cor_hover_botao_borda: "#99E8B4",
        cor_tema_step_default: "#26A150",
        cor_ponta_inferior_lateral_esquerda: "#68d08c",
        consentimento_cookie_text: "Armazenamos cookies para melhorar sua experi\xeancia de navega\xe7\xe3o. Conheca nossa [[Pol\xedtica de Privacidade]]",
        code_tag_manager: "MKJH6BG",
        logo_empresa: {
            data: {
                attributes: {
                    url: "/wl/ELECTY/logo_empresa.png"
                }
            }
        },
        logo_empresa_2: {
            data: {
                attributes: {
                    url: "/wl/ELECTY/logo_empresa_2.png"
                }
            }
        },
        logo_empresa_rodape: {
            data: null
        },
        favicon: {
            data: {
                attributes: {
                    url: "/wl/ELECTY/favicon.svg"
                }
            }
        },
        bg_img_frame: {
            data: {
                attributes: {
                    url: "/wl/ELECTY/bg_img_frame.png"
                }
            }
        },
        splash: {
            data: {
                attributes: {
                    url: "/wl/ELECTY/splash.gif"
                }
            }
        },
        card_esquerda: {
            data: {
                attributes: {
                    url: "/wl/ELECTY/card_esquerda.png"
                }
            }
        },
        bg_img_redirect: {
            data: {
                attributes: {
                    url: "/wl/ELECTY/bg_img_redirect.png"
                }
            }
        },
        icone_whatsapp: {
            data: {
                attributes: {
                    url: "/wl/ELECTY/icone_whatsapp.png"
                }
            }
        },
        icone_duvidas: {
            data: {
                attributes: {
                    url: "/wl/ELECTY/icone_duvidas.png"
                }
            }
        },
        bg_img_manutencao: {
            data: {
                attributes: {
                    url: "/wl/ELECTY/bg_img_manutencao.png"
                }
            }
        },
        bg_img_error_aplicacao: {
            data: {
                attributes: {
                    url: "/wl/ELECTY/bg_img_error_aplicacao.png"
                }
            }
        },
        Onboarding: {
            header_color: false,
            titulo_bem_vindo: "Bem vindo a Electy!",
            titulo_onboarding_1: "Por que a Electy?",
            descricao_onboarding_1: "Voc\xea vai conhecer um novo jeito de consumir energia: mais barata, mais sustent\xe1vel, com mais liberdade de escolha e facilidade!",
            titulo_onboarding_2: "Energia na palma da sua m\xe3o",
            descricao_onboarding_2: "Escolha a usina parceira e o tipo de energia que ir\xe1 consumir na sua casa.  Economize na conta de luz e tenha uma atitude sustent\xe1vel.  ",
            titulo_onboarding_3: "Muito simples e seguro ",
            descricao_onboarding_3: "A contrata\xe7\xe3o \xe9 simples e segura. E n\xe3o se preocupe com falta de luz, pois voc\xea continuar\xe1 ligado ao fornecimento tradicional de energia.",
            titulo_onboarding_4: "Escolha o melhor para voc\xea ",
            descricao_onboarding_4: "Informe o seu consumo. A gente apresenta as possibilidades. Voc\xea assina o contrato e n\xf3s avisamos \xe0 usina e a sua distribuidora.",
            titulo_onboarding_5: "Economia o ano inteiro ",
            descricao_onboarding_5: "No final do ciclo de consumo, voc\xea vai passar a pagar duas contas mas, o valor total ser\xe1 at\xe9 25% menor do que aquele que voc\xea paga hoje. ",
            titulo_onboarding_6: "Fa\xe7a sua escolha",
            descricao_onboarding_6: "Chega de pagar caro por energia el\xe9trica! Seja sustent\xe1vel e economize. ",
            background_img: null,
            bg_img_onboarding_1: {
                data: {
                    attributes: {
                        url: "/wl/ELECTY/bg_img_onboarding_1.gif"
                    }
                }
            },
            bg_img_onboarding_2: {
                data: {
                    attributes: {
                        url: "/wl/ELECTY/bg_img_onboarding_2.gif"
                    }
                }
            },
            bg_img_onboarding_3: {
                data: {
                    attributes: {
                        url: "/wl/ELECTY/bg_img_onboarding_3.gif"
                    }
                }
            },
            bg_img_onboarding_4: {
                data: {
                    attributes: {
                        url: "/wl/ELECTY/bg_img_onboarding_4.gif"
                    }
                }
            },
            bg_img_onboarding_5: {
                data: {
                    attributes: {
                        url: "/wl/ELECTY/bg_img_onboarding_5.gif"
                    }
                }
            },
            bg_img_onboarding_6: {
                data: {
                    attributes: {
                        url: "/wl/ELECTY/bg_img_onboarding_6.gif"
                    }
                }
            }
        },
        Usuario: {
            bg_img_confirmacao_conta: {
                data: {
                    attributes: {
                        url: "/wl/ELECTY/bg_img_confirmacao_conta.svg"
                    }
                }
            },
            bg_img_email_enviado: {
                data: {
                    attributes: {
                        url: "/wl/ELECTY/bg_img_email_enviado.svg"
                    }
                }
            },
            bg_img_erro_link_invalido: {
                data: {
                    attributes: {
                        url: "/wl/ELECTY/bg_img_erro_link_invalido.svg"
                    }
                }
            },
            bg_img_password_reset: {
                data: {
                    attributes: {
                        url: "/wl/ELECTY/bg_img_password_reset.svg"
                    }
                }
            },
            bg_img_password_reset_success: {
                data: {
                    attributes: {
                        url: "/wl/ELECTY/bg_img_password_reset_success.svg"
                    }
                }
            },
            bg_img_reenviar_email: {
                data: {
                    attributes: {
                        url: "/wl/ELECTY/bg_img_reenviar_email.svg"
                    }
                }
            },
            bg_img_sem_conta: {
                data: {
                    attributes: {
                        url: "/wl/ELECTY/bg_img_sem_conta.png"
                    }
                }
            }
        },
        Calculadora: {
            cor_botao_select: "#26A150",
            texto_descricao_consumo: null,
            cor_hover_botao_icon: "#99E8B4",
            habilitar_contrato_pf: true,
            habilitar_contrato_pj: true,
            habilitar_captura_fornecedor: false,
            texto_captura_fornecedor: null,
            bg_img_calculadora_success: {
                data: {
                    attributes: {
                        url: "/wl/ELECTY/bg_img_calculadora_success.png"
                    }
                }
            },
            bg_img_calculadora_not_found: {
                data: {
                    attributes: {
                        url: "/wl/ELECTY/bg_img_calculadora_not_found.png"
                    }
                }
            },
            titulo_sem_estoque: "Ah, que pena! A energia esgotou na sua regi\xe3o, devido a alta demanda.",
            descricao_sem_estoque: "Estamos trabalhando para ampliar a oferta de energia limpa e oferec\xea-la novamente em sua regi\xe3o. N\xe3o desanime! Enquanto isso, voc\xea est\xe1 em nossa lista de espera e vamos te mantendo atualizado de todas as novidades da Electy.",
            img_sem_estoque: {
                data: {
                    attributes: {
                        url: "/wl/ELECTY/img_sem_estoque.png"
                    }
                }
            },
            titulo_nao_atendida: "Ah, que pena! No momento, n\xe3o temos energia dispon\xedvel na sua regi\xe3o. ",
            descricao_nao_atendida: "Estamos trabalhando para, em breve, oferecer energia limpa e mais barata para voc\xea e todo Brasil. N\xe3o desanime! Enquanto isso, voc\xea est\xe1 em nossa lista de espera e vamos te mantendo atualizado de todas as novidades da Electy.\nAgradecemos a sua compreens\xe3o e ficamos felizes pelo seu interesse em contribuir para um planeta mais sustent\xe1vel!",
            img_nao_atendida: {
                data: {
                    attributes: {
                        url: "/wl/ELECTY/img_nao_atendida.png"
                    }
                }
            },
            img_form_fornecedor: {
                data: null
            },
            img_sem_consumo_minimo: {
                data: {
                    attributes: {
                        url: "/wl/ELECTY/img_sem_consumo_minimo.png"
                    }
                }
            }
        },
        Coleta_Dados_Usuario: {
            bg_img_code_sms: {
                data: {
                    attributes: {
                        url: "/wl/ELECTY/bg_img_code_sms.png"
                    }
                }
            },
            bg_img_confirmacao_dados_confirmacao_sms: {
                data: {
                    attributes: {
                        url: "/wl/ELECTY/bg_img_confirmacao_dados_confirmacao_sms.svg"
                    }
                }
            },
            bg_img_localizacao: {
                data: {
                    attributes: {
                        url: "/wl/ELECTY/bg_img_localizacao.png"
                    }
                }
            },
            bg_img_localizacao_nao_encontrado: {
                data: {
                    attributes: {
                        url: "/wl/ELECTY/bg_img_localizacao_nao_encontrado.png"
                    }
                }
            }
        },
        Formulario: {
            bg_img_form: {
                data: {
                    attributes: {
                        url: "/wl/ELECTY/bg_img_form.png"
                    }
                }
            },
            bg_img_form_confirmacao: {
                data: {
                    attributes: {
                        url: "/wl/ELECTY/bg_img_form_confirmacao.png"
                    }
                }
            },
            bg_img_tooltip_form: {
                data: {
                    attributes: {
                        url: "/wl/ELECTY/bg_img_tooltip_form.png"
                    }
                }
            }
        },
        Pessoa_Fisica: {
            Step_1: {
                bg_img_dados_nao_encontrados: {
                    data: {
                        attributes: {
                            url: "/wl/ELECTY/bg_img_dados_nao_encontrados.png"
                        }
                    }
                },
                bg_img_dados_pessoais: {
                    data: {
                        attributes: {
                            url: "/wl/ELECTY/bg_img_dados_pessoais.png"
                        }
                    }
                }
            },
            Step_2: {
                bg_img_confirme_dados_endereco: {
                    data: {
                        attributes: {
                            url: "/wl/ELECTY/bg_img_confirme_dados_endereco.png"
                        }
                    }
                },
                bg_img_endereco: {
                    data: {
                        attributes: {
                            url: "/wl/ELECTY/bg_img_endereco.png"
                        }
                    }
                }
            },
            Step_3: {
                bg_img_rg: {
                    data: {
                        attributes: {
                            url: "/wl/ELECTY/bg_img_rg.png"
                        }
                    }
                },
                bg_img_tooltip_rg: {
                    data: {
                        attributes: {
                            url: "/wl/ELECTY/bg_img_tooltip_rg.png"
                        }
                    }
                },
                bg_img_documento_adicionado: {
                    data: {
                        attributes: {
                            url: "/wl/ELECTY/bg_img_documento_adicionado.svg"
                        }
                    }
                }
            },
            Step_4: {
                bg_img_conta_luz: {
                    data: {
                        attributes: {
                            url: "/wl/ELECTY/bg_img_conta_luz.png"
                        }
                    }
                },
                bg_img_tooltip_conta_luz: {
                    data: {
                        attributes: {
                            url: "/wl/ELECTY/bg_img_tooltip_conta_luz.png"
                        }
                    }
                },
                bg_img_conta_luz_adicionada: {
                    data: {
                        attributes: {
                            url: "/wl/ELECTY/bg_img_conta_luz_adicionada.svg"
                        }
                    }
                }
            },
            Step_5: {
                bg_img_confirmacao_conta: {
                    data: {
                        attributes: {
                            url: "/wl/ELECTY/bg_img_confirmacao_conta.png"
                        }
                    }
                }
            }
        },
        Pessoa_Juridica: {
            Step_1_pj: {
                bg_img_contrado_social_pj: {
                    data: {
                        attributes: {
                            url: "/wl/ELECTY/bg_img_contrado_social_pj.png"
                        }
                    }
                },
                bg_img_tooltip_contrado_social_pj: {
                    data: {
                        attributes: {
                            url: "/wl/ELECTY/bg_img_tooltip_contrado_social_pj.png"
                        }
                    }
                },
                bg_img_vamos_comecar_pj: {
                    data: {
                        attributes: {
                            url: "/wl/ELECTY/bg_img_vamos_comecar_pj.png"
                        }
                    }
                },
                bg_img_dados_empresa_pj: {
                    data: {
                        attributes: {
                            url: "/wl/ELECTY/bg_img_dados_empresa_pj.png"
                        }
                    }
                },
                bg_img_contrado_social_adicionado_pj: {
                    data: {
                        attributes: {
                            url: "/wl/ELECTY/bg_img_contrado_social_adicionado_pj.svg"
                        }
                    }
                },
                bg_img_confirme_dados_empresa_pj: {
                    data: {
                        attributes: {
                            url: "/wl/ELECTY/bg_img_confirme_dados_empresa_pj.png"
                        }
                    }
                },
                bg_img_possui_demanda_pj: {
                    data: {
                        attributes: {
                            url: "/wl/ELECTY/bg_img_possui_demanda_pj.png"
                        }
                    }
                },
                bg_img_tooltip_possui_demanda_pj: {
                    data: {
                        attributes: {
                            url: "/wl/ELECTY/bg_img_tooltip_possui_demanda_pj.png"
                        }
                    }
                }
            },
            Step_2_pj: {
                bg_img_rg_pj: {
                    data: {
                        attributes: {
                            url: "/wl/ELECTY/bg_img_rg_pj.png"
                        }
                    }
                },
                bg_img_tooltip_rg_pj: {
                    data: {
                        attributes: {
                            url: "/wl/ELECTY/bg_img_tooltip_rg_pj.png"
                        }
                    }
                }
            },
            Step_3_pj: {
                bg_img_conta_luz_pj: {
                    data: {
                        attributes: {
                            url: "/wl/ELECTY/bg_img_conta_luz_pj.png"
                        }
                    }
                },
                bg_img_tooltip_conta_luz_pj: {
                    data: {
                        attributes: {
                            url: "/wl/ELECTY/bg_img_tooltip_conta_luz_pj.png"
                        }
                    }
                },
                bg_img_conta_luz_adicionada_pj: {
                    data: {
                        attributes: {
                            url: "/wl/ELECTY/bg_img_conta_luz_adicionada_pj.svg"
                        }
                    }
                }
            },
            Step_4_pj: {
                bg_img_dados_submetidos_pj: {
                    data: {
                        attributes: {
                            url: "/wl/ELECTY/bg_img_dados_submetidos_pj.png"
                        }
                    }
                }
            }
        },
        Email: {
            bg_img_confirmacao_conta: {
                data: {
                    attributes: {
                        url: "/wl/ELECTY/bg_img_email_confirmacao_conta.svg"
                    }
                }
            },
            bg_img_contrato_assinado: {
                data: {
                    attributes: {
                        url: "/wl/ELECTY/img_contrato_assinado.svg"
                    }
                }
            }
        },
        Mercado_Livre: {
            bg_img_sucesso_solicitacao_contato: {
                data: {
                    attributes: {
                        url: "/wl/ELECTY/bg_img_sucesso_solicitacao_contato.svg"
                    }
                }
            },
            bg_img_conta_luz_ml: {
                data: {
                    attributes: {
                        url: "/wl/ELECTY/bg_img_conta_luz_ml.png"
                    }
                }
            },
            bg_img_tooltip_conta_luz_ml: {
                data: {
                    attributes: {
                        url: "/wl/ELECTY/bg_img_tooltip_conta_luz_ml.png"
                    }
                }
            },
            bg_img_conta_luz_adicionada_ml: {
                data: {
                    attributes: {
                        url: "/wl/ELECTY/bg_img_conta_luz_adicionada_ml.svg"
                    }
                }
            },
            entenda_porque_1: {
                data: {
                    attributes: {
                        url: "/wl/ELECTY/entenda_porque_1.gif"
                    }
                }
            },
            bg_img_contrato_social_adicionado_ml: {
                data: {
                    attributes: {
                        url: "/wl/ELECTY/bg_img_contrato_social_adicionado_ml.svg"
                    }
                }
            },
            bg_img_documento_adicionado_ml: {
                data: {
                    attributes: {
                        url: "/wl/ELECTY/bg_img_documento_adicionado_ml.svg"
                    }
                }
            },
            bg_img_contrato_social_ml: {
                data: {
                    attributes: {
                        url: "/wl/ELECTY/bg_img_contrato_social_ml.png"
                    }
                }
            },
            bg_img_tooltip_contrado_social: {
                data: {
                    attributes: {
                        url: "/wl/ELECTY/bg_img_tooltip_contrado_social.png"
                    }
                }
            },
            bg_img_tooltip_documento_ml: {
                data: {
                    attributes: {
                        url: "/wl/ELECTY/bg_img_tooltip_documento_ml.png"
                    }
                }
            },
            bg_img_documento_ml: {
                data: {
                    attributes: {
                        url: "/wl/ELECTY/bg_img_documento_ml.png"
                    }
                }
            }
        },
        Zapsign: {
            bg_img_assinatura_contrato: {
                data: {
                    attributes: {
                        url: "/wl/ELECTY/bg_img_assinatura_contrato.png"
                    }
                }
            },
            bg_img_contrato_assinado: {
                data: {
                    attributes: {
                        url: "/wl/ELECTY/bg_img_contrato_assinado.png"
                    }
                }
            }
        }
    }
};

// EXTERNAL MODULE: ./src/constants/wl/voltta/index.js
var voltta = __webpack_require__(63802);
;// CONCATENATED MODULE: ./src/services/wl/index.js
/* provided dependency */ var process = __webpack_require__(34155);



/**
 * Realiza uma consulta na tabela wl-data do Strapi, salvando os dados em um token
 * @param {context}   Context     Quando chamado por um getServerSideProps|getStaticProps
 * @param {req}       Request     Quando chamado por um API
 * @param {res}       Response    Quando chamado por um API
 * @param {keyName}   String|Null Chave para buscar um valor especifico no GraphQL query
 * @returns JSON
 */ var GetWLData = function() {
    var keyName = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        keyName: ""
    }).keyName;
    var wlDatas = getWlData(process.env.COMPANY_KEY);
    if (!wlDatas) {
        return {
            status: false,
            error: true,
            data: "empty"
        };
    }
    var result = {
        status: true,
        data: wlDatas.attributes
    };
    return result;
};
var getWlData = function(company) {
    switch(company){
        case "ELECTY":
            return ELECTY_wlDatas;
        case "VOLTTA":
        case "voltta":
            return voltta/* wlDatas */.w;
        case "ENERGISA":
        case "(re)energisa":
        case "energisa":
        case "reenergisa":
            return wlDatas;
        default:
            console.log({
                company: company
            });
            return false;
    }
};


/***/ })

}]);